export const mbaColleges = [
  {
    "Sr No": 1.0,
    "Name of university/College":
      "Alkesh Dinesh Mody Institute for Financial and Management Studies",
    "College as available in SC": "Not available in SC",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "Alkesh Dinesh Mody Institute for Financial and Management Studies - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Kavita",
    "SPOC Email ID": "kavita@admi.mu.ac.in",
    "SPOC Contact number": 9819925109.0,
  },
  {
    "Sr No": 2.0,
    "Name of university/College": "Alliance University",
    "College as available in SC":
      "Amrita Univ. Coimbatore - Amitra University, Coimbatore",
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus: "Alliance University-Bangalore",
    "If existing in Institution master": "Alliance University-Bangalore",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 3.0,
    "Name of university/College": "Amrita University",
    "College as available in SC": "Amrita University (AU) - Bangalore",
    "Number of campuses": 3.0,
    City: "Coimbatore",
    Campus: "Amrita Vishwa Vidyapeetham-Coimbatore",
    "If existing in Institution master": null,
    "SPOC Name": "Shakti Prasad",
    "SPOC Email ID": "p_shakti@asb.kochi.amruta.edu",
    "SPOC Contact number": 9497498319.0,
  },
  {
    "Sr No": 4.0,
    "Name of university/College": "Amrita University",
    "College as available in SC": "Amrita University (AU) - Kochi",
    "Number of campuses": null,
    City: "Bangalore",
    Campus: "Amrita Vishwa Vidyapeetham-Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Shakti Prasad",
    "SPOC Email ID": "p_shakti@asb.kochi.amruta.edu",
    "SPOC Contact number": 9497498319.0,
  },
  {
    "Sr No": 5.0,
    "Name of university/College": "Amrita University",
    "College as available in SC":
      "BGU Bhubaneswar - Birla Global University - Bhubaneswar",
    "Number of campuses": null,
    City: "Kochi",
    Campus: "Amrita Vishwa Vidyapeetham-Kochi",
    "If existing in Institution master": null,
    "SPOC Name": "Shakti Prasad",
    "SPOC Email ID": "p_shakti@asb.kochi.amruta.edu",
    "SPOC Contact number": 7381041822.0,
  },
  {
    "Sr No": 6.0,
    "Name of university/College":
      "Atharva Institute of Management Studies (AIMS)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "AIMS Mumbai - Atharva Institute of Management Studies - Mumbai",
    "If existing in Institution master":
      "AIMS Mumbai - Atharva Institute of Management Studies - Mumbai",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 7.0,
    "Name of university/College": "Balaji Institute of Telecom and Management",
    "College as available in SC":
      "CIMR Mumbai - Chetana Institute of Management and Research - Mumbai",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "Balaji Institute of Telecom and Management",
    "If existing in Institution master":
      "Balaji Institute of Telecom and Management",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": "9892 979 201",
  },
  {
    "Sr No": 8.0,
    "Name of university/College": "Banaras Hindu University (BHU) ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Varanasi",
    Campus: "Banaras Hindu University (BHU) - Varanasi - Uttar Pradesh",
    "If existing in Institution master":
      "Banaras Hindu University (BHU) - Varanasi - Uttar Pradesh",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 9.0,
    "Name of university/College":
      "Bharati Vidyapeeth Institute Of Management and Entrepreneurship Development (BVIMED)",
    "College as available in SC": "Christ University Bangalore",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus:
      "BVIMED Pune - Bharati Vidyapeeth Institute Of Management and Entrepreneurship Development - Pune",
    "If existing in Institution master":
      "BVIMED Pune - Bharati Vidyapeeth Institute Of Management and Entrepreneurship Development - Pune",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 10.0,
    "Name of university/College": "Birla Global University",
    "College as available in SC":
      "FMS Delhi - Faculty of Management Studies - Delhi",
    "Number of campuses": 1.0,
    City: "Bhubaneswar",
    Campus: "Birla Global University - Bhubaneswar",
    "If existing in Institution master": null,
    "SPOC Name": "Sumit Kumar Barpanda",
    "SPOC Email ID": "sumit.barpanda@bgu.ac.in",
    "SPOC Contact number": 7381041822.0,
  },
  {
    "Sr No": 11.0,
    "Name of university/College":
      "Birla Institute of Management Technology ( BIMTECH)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Noida",
    Campus: "BIMTECH Noida- Birla Institute of Management Technology Noida",
    "If existing in Institution master":
      "BIMTECH Noida- Birla Institute of Management Technology Noida",
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 12.0,
    "Name of university/College": "BITS School of Management",
    "College as available in SC": "FOSTIIMA Group Of Institutions - New Delhi",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "BITS School of Management-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Swapnil Sawant",
    "SPOC Email ID": "swapnil.sawant@bitsom.edu.in",
    "SPOC Contact number": 9702555678.0,
  },
  {
    "Sr No": 13.0,
    "Name of university/College": "Calcutta University",
    "College as available in SC":
      "GBS Kolkata - Globsyn Business School - Kolkata",
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "Calcutta University",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },

  {
    "Sr No": 14.0,
    "Name of university/College": "Chandigarh University",
    "College as available in SC": "GIM Goa - Goa Institute of Management, Goa",
    "Number of campuses": 1.0,
    City: "Chandigarh",
    Campus: "Chandigarh University",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 15.0,
    "Name of university/College": "Chennai Mathematical Institute (CMI)",
    "College as available in SC":
      "GLIM Chennai - Great Lakes Institute of Management, Chennai",
    "Number of campuses": 1.0,
    City: "Chennai",
    Campus: "CMI Chennai - Chennai Mathematical Institute - Chennai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 16.0,
    "Name of university/College": "Chetana Institute of Management and Research",
    "College as available in SC":
      "GLIM Gurgaon- Great Lakes Institute of Management, Gurgaon",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "CIMR Mumbai - Chetana Institute of Management and Research - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Ms. Neena Katkar",
    "SPOC Email ID": "placement@cimr.in/neena_chetana@rediffmail.com",
    "SPOC Contact number": "9892 979 201",
  },
  {
    "Sr No": 17.0,
    "Name of university/College": "Chitkara University ",
    "College as available in SC":
      "IBS Bangalore - ICFAI Business School - Bangalore",
    "Number of campuses": 1.0,
    City: "Chandigarh",
    Campus: "Chitkara University -Chandigarh",
    "If existing in Institution master": null,
    "SPOC Name": "Gurpreet Singh",
    "SPOC Email ID": "gurpreet.crm@chitkara.edu.in",
    "SPOC Contact number": "97794 50713",
  },
  {
    "Sr No": 18.0,
    "Name of university/College": "Christ University",
    "College as available in SC": 1.0,
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus: "Christ University Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Moly",
    "SPOC Email ID": "placements@mba.christuniversity.in",
    "SPOC Contact number": null,
  },
  {
    "Sr No": 19.0,
    "Name of university/College": "Dayalbagh Educational Institute ( DEI)",
    "College as available in SC": "IBS Gurgaon - IBS Business School - Gurgaon",
    "Number of campuses": 1.0,
    City: "Agra",
    Campus: "DEI Agra - Dayalbagh Educational Institute - Agra",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 20.0,
    "Name of university/College": "Delhi School of Economics ( DSE)",
    "College as available in SC": "IBS Hyderabad",
    "Number of campuses": 1.0,
    City: "Delhi",
    Campus: "DSC Delhi - Delhi School of Economics - Delhi",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 21.0,
    "Name of university/College": "Department of Management Sciences (PUMBA) ",
    "College as available in SC": "IBS- Jaipur",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "PUMBA Pune- Department of Management Sciences (PUMBA) Pune",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 22.0,
    "Name of university/College":
      "Durgadevi Saraf Institute of Management Studies (DSIMS)",
    "College as available in SC":
      "ICFAIBS Mumbai - ICFAI Business School - Mumbai",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "DSIMS Mumbai - Durgadevi Saraf Institute of Management Studies - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 23.0,
    "Name of university/College": "Faculty of Management Studies - Delhi",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Delhi",
    Campus: "Faculty of Management Studies - Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Saaransh Jain",
    "SPOC Email ID": "placement@fms.edu",
    "SPOC Contact number": 9769309596.0,
  },
  {
    "Sr No": 24.0,
    "Name of university/College": "FLAME University (FU)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "FU Pune - FLAME University - Pune",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 25.0,
    "Name of university/College": "FORE School Of Management",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Delhi",
    Campus: "FORE School Of Management-Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Simar Sakhuja",
    "SPOC Email ID": "placements.hrmlr@tiss.edu",
    "SPOC Contact number": 9123568804.0,
  },
  {
    "Sr No": 26.0,
    "Name of university/College": "FOSTIIMA Group Of Institutions",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "New Delhi",
    Campus: "FOSTIIMA Group Of Institutions - New Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Neetu",
    "SPOC Email ID": "neetu.sharma@fostiima.org",
    "SPOC Contact number": null,
  },
  {
    "Sr No": 27.0,
    "Name of university/College": "Globsyn Business School",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "Globsyn Business School - Kolkata",
    "If existing in Institution master": null,
    "SPOC Name": "Banti Biswas",
    "SPOC Email ID": "banti.biswas@globsyn.edu.in",
    "SPOC Contact number": "98368 92956",
  },
  {
    "Sr No": 28.0,
    "Name of university/College": "Goa Institute of Management",
    "College as available in SC":
      "IIFM Bhopal - Indian Institute of Forest Management - Bhopal",
    "Number of campuses": 1.0,
    City: "Sanquelim",
    Campus: "Goa Institute of Management-Goa",
    "If existing in Institution master": null,
    "SPOC Name": "Akhila Ganesh ",
    "SPOC Email ID": "placement.bifs@gim.ac.in",
    "SPOC Contact number": 8886247759.0,
  },
  {
    "Sr No": 29.0,
    "Name of university/College":
      "Gokhale Institute of Politics and Economics  (GIPE)",
    "College as available in SC":
      "IIM Kozhikode - Indian Institute of Management - Kozhikode",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "GIPE Pune - Gokhale Institute of Politics and Economics - Pune",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 30.0,
    "Name of university/College": "Great Lakes Institute of Management",
    "College as available in SC":
      "IIM Lucknow - Indian Institute of Management - Lucknow",
    "Number of campuses": 2.0,
    City: "Chennai",
    Campus: "Great Lakes Institute of Management-Chennai",
    "If existing in Institution master": null,
    "SPOC Name": "Sivakumar",
    "SPOC Email ID": "sivakumar.n@greatlakes.edu.in",
    "SPOC Contact number": 7550020176.0,
  },
  {
    "Sr No": 31.0,
    "Name of university/College": "Great Lakes Institute of Management",
    "College as available in SC": null,
    "Number of campuses": 2,
    City: "Gurgaon",
    Campus: "Great Lakes Institute of Management-Gurgaon",
    "If existing in Institution master": null,
    "SPOC Name": "Garima Sharma ",
    "SPOC Email ID": "garima.pgdm24g@greatlakes.edu.in ",
    "SPOC Contact number": 9810923933.0,
  },

  {
    "Sr No": 32.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC": "IIM-Ahmedabad",
    "Number of campuses": 9.0,
    City: "Bangalore",
    Campus: "ICFAI Business School (IBS)-Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Philip J",
    "SPOC Email ID": "philip@ibsindia.org",
    "SPOC Contact number": "988 604 3633",
  },
  {
    "Sr No": 33.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC": "IIM Calcutta",
    "Number of campuses": null,
    City: "Dehradun",
    Campus: "ICFAI Business School (IBS)-Dehradun",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 34.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC":
      "IIM Indore- Indian Institute of Management Indore",
    "Number of campuses": null,
    City: "Gurgaon",
    Campus: "ICFAI Business School (IBS)-Gurgaon",
    "If existing in Institution master": null,
    "SPOC Name": "Archana ",
    "SPOC Email ID": "-",
    "SPOC Contact number": 9811695160.0,
  },
  {
    "Sr No": 35.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC": "IIM Shillong",
    "Number of campuses": null,
    City: "Hyderabad",
    Campus: "ICFAI Business School (IBS)-Hyderabad",
    "If existing in Institution master": null,
    "SPOC Name": "Satyanarayana Goud",
    "SPOC Email ID": "msngoud@ibsindia.org",
    "SPOC Contact number": 9393026900.0,
  },
  {
    "Sr No": 36.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC":
      "Indian Institute of Management Amritsar (IIM-AM)",
    "Number of campuses": null,
    City: "Jaipur",
    Campus: "ICFAI Business School (IBS)-Jaipur",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 37.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC": "IIM- Bangalore",
    "Number of campuses": null,
    City: "Mumbai",
    Campus: "ICFAI Business School (IBS)-Mumbai ",
    "If existing in Institution master": null,
    "SPOC Name": "Mr. Abhijeet Controllu",
    "SPOC Email ID": "abhijeetc@ibsindia.org",
    "SPOC Contact number": 9619761222.0,
  },
  {
    "Sr No": 38.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC": "IIM-Kashipur",
    "Number of campuses": null,
    City: "Pune",
    Campus: "ICFAI Business School (IBS)-Pune",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 39.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC":
      "IIM Rohtak - Indian Institute of Management, Rohtak",
    "Number of campuses": null,
    City: "Ahmedabad",
    Campus: "ICFAI Business School (IBS)-Ahmedabad",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 40.0,
    "Name of university/College": "ICFAI Business School (IBS)",
    "College as available in SC":
      "IIM Trichy- Indian Institute of Management, Trichy",
    "Number of campuses": null,
    City: "Kolkata",
    Campus: "ICFAI Business School (IBS)-Kolkata",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 41.0,
    "Name of university/College": "IGIDR",
    "College as available in SC": "IIM-Udaipur",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "IGIDR Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 42.0,
    "Name of university/College": "Indian Institute of Foreign Trade",
    "College as available in SC":
      "Indian Institute of Management Visakhapatnam (IIM-V)",
    "Number of campuses": 2.0,
    City: "New Delhi",
    Campus:
      "Indian Institute of Foreign Trade- Delhi (Qutab Institutional Area, New Delhi)",
    "If existing in Institution master": null,
    "SPOC Name": "Kashyapa C",
    "SPOC Email ID": "placements@iift.edu",
    "SPOC Contact number": 7893412396.0,
  },
  {
    "Sr No": 43.0,
    "Name of university/College": "Indian Institute of Foreign Trade",
    "College as available in SC":
      "IMT Ghaziabad - Institute of Management Technology, Ghaziabad",
    "Number of campuses": null,
    City: "Kolkata",
    Campus:
      "Indian Institute of Foreign Trade- Kolkata (Madurdaha, Chowbaga, Kolkata)",
    "If existing in Institution master": null,
    "SPOC Name": "Kashyapa C",
    "SPOC Email ID": "placements@iift.edu",
    "SPOC Contact number": 7893412396.0,
  },
  {
    "Sr No": 44.0,
    "Name of university/College": "Indian Institute of Forest Management",
    "College as available in SC":
      "IMT Hyderabad- Institute of Management Technology, Hyderabad",
    "Number of campuses": 1.0,
    City: "Bhopal",
    Campus: "Indian Institute of Forest Management - Bhopal",
    "If existing in Institution master": null,
    "SPOC Name": "Dr. Aditya Gupta",
    "SPOC Email ID": "placements@iifm.ac.in",
    "SPOC Contact number": 9479627291.0,
  },
  {
    "Sr No": 45.0,
    "Name of university/College": "Indian Institute of Management - Kozhikode",
    "College as available in SC":
      "Institute of Management Technology (IMT) - Nagpur",
    "Number of campuses": 1.0,
    City: "Kozhikode",
    Campus: "Indian Institute of Management - Kozhikode",
    "If existing in Institution master": null,
    "SPOC Name": "Kashish Aggarwal",
    "SPOC Email ID": "placements@iimk.ac.in",
    "SPOC Contact number": 8954015464.0,
  },
  {
    "Sr No": 46.0,
    "Name of university/College": "Indian Institute of Management - Lucknow",
    "College as available in SC":
      "IRMA Anand - Institute of Rural Management Anand - Anand",
    "Number of campuses": 1.0,
    City: "Lucknow",
    Campus: "Indian Institute of Management - Lucknow",
    "If existing in Institution master": null,
    "SPOC Name": "Aman Jain",
    "SPOC Email ID": "placecom@iiml.ac.in",
    "SPOC Contact number": 9810900824.0,
  },
  {
    "Sr No": 47.0,
    "Name of university/College": "Indian Institute of Management - Mumbai",
    "College as available in SC":
      "ISBM Pune - International School of Business and Media - Pune",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Indian Institute of Management - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "sowndar",
    "SPOC Email ID": "placements@nitie.ac.in",
    "SPOC Contact number": 7904791482.0,
  },
  {
    "Sr No": 48.0,
    "Name of university/College": "Indian Institute of Management -Ahmedabad",
    "College as available in SC":
      "ITM GOI Navi Mumbai - ITM Group of Institutions - Navi Mumbai",
    "Number of campuses": 1.0,
    City: "Ahmedabad",
    Campus: "Indian Institute of Management -Ahmedabad",
    "If existing in Institution master": null,
    "SPOC Name": "Mukul",
    "SPOC Email ID": "p22mukul@iim.ac.in",
    "SPOC Contact number": 9873551097.0,
  },
  {
    "Sr No": 49.0,
    "Name of university/College":
      "Indian Institute of Management Bodhgaya (IIM-BG)",
    "College as available in SC":
      "ITMBS Chennai - ITM Business School - Chennai",
    "Number of campuses": 1.0,
    City: "Bodhgaya",
    Campus: "Indian Institute of Management Bodhgaya (IIM-BG)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 50.0,
    "Name of university/College": "Indian Institute of Management -Calcutta",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "Indian Institute of Management -Calcutta",
    "If existing in Institution master": null,
    "SPOC Name": "Apoorv",
    "SPOC Email ID": "placement@iimcal.ac.in",
    "SPOC Contact number": 7605026266.0,
  },
  {
    "Sr No": 51.0,
    "Name of university/College": "Indian Institute of Management Indore",
    "College as available in SC":
      "JBIMS Mumbai - Jamnalal Bajaj Institute of Management Studies - Mumbai",
    "Number of campuses": 1.0,
    City: "Indore",
    Campus: "Indian Institute of Management Indore",
    "If existing in Institution master": null,
    "SPOC Name": "Saransh Saxena",
    "SPOC Email ID": "placement@iimidr.ac.in",
    "SPOC Contact number": 9818545799.0,
  },
  {
    "Sr No": 52.0,
    "Name of university/College":
      "Indian Institute of Management Jammu (IIM-J)",
    "College as available in SC":
      "Kirloskar Institute of Advanced Management Studies-Pune",
    "Number of campuses": 1.0,
    City: "Jammu",
    Campus: "Indian Institute of Management Jammu (IIM-J)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 53.0,
    "Name of university/College":
      "Indian Institute of Management Nagpur (IIM-N)",
    "College as available in SC":
      "KJSIMSR Mumbai - KJ Somaiya Institute of Management Studies and Research Mumbai",
    "Number of campuses": 1.0,
    City: "Nagpur",
    Campus: "Indian Institute of Management Nagpur (IIM-N)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 54.0,
    "Name of university/College": "International Management Institute (IMI)",
    "College as available in SC":
      "LBSIM Delhi - Lal Bahadur Shastri Institute Of Management - Delhi",
    "Number of campuses": 1.0,
    City: "Bhubaneswar",
    Campus: "IMI Bhubaneshwar",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },

  {
    "Sr No": 55.0,
    "Name of university/College":
      "Indian Institute of Management Ranchi (IIM - R)",
    "College as available in SC":
      "LPU PHAGWARA - LOVELY PROFESSIONAL UNIVERSITY - PHAGWARA - PUNJAB",
    "Number of campuses": 1.0,
    City: "Ranchi",
    Campus: "Indian Institute of Management Ranchi (IIM - R)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 56.0,
    "Name of university/College":
      "Indian Institute of Management Sambalpur (IIM-SB)",
    "College as available in SC":
      "LIBA Chennai - Loyola Institute of Business Administration - Chennai",
    "Number of campuses": 1.0,
    City: "Sambalpur",
    Campus: "Indian Institute of Management Sambalpur (IIM-SB)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 57.0,
    "Name of university/College": "Indian Institute of Management -Shillong",
    "College as available in SC":
      "MDI Gurgaon- Management Development Institute Gurgaon",
    "Number of campuses": 1.0,
    City: "Shillong",
    Campus: "Indian Institute of Management -Shillong",
    "If existing in Institution master": null,
    "SPOC Name": "Nishad ",
    "SPOC Email ID": "placecomm.iims@gmail.com",
    "SPOC Contact number": 9876886233.0,
  },
  {
    "Sr No": 58.0,
    "Name of university/College":
      "Indian Institute of Management Sirmaur (IIM-SR)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Sirmaur",
    Campus: "Indian Institute of Management Sirmaur (IIM-SR)",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 59.0,
    "Name of university/College": "Indian Institute of Management-Amritsar",
    "College as available in SC":
      "SVKM NMIMS Mumbai - Mukesh Patel School of Technology Management & Engineering, Mumbai",
    "Number of campuses": 1.0,
    City: "Amritsar",
    Campus: "Indian Institute of Management-Amritsar",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "placements@iimamritsar.ac.in",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 60.0,
    "Name of university/College": "Indian Institute of Management-Bangalore",
    "College as available in SC":
      "NMIMS Bangalore - Narsee Monjee Institute of Management Studies, Bangalore",
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus: "Indian Institute of Management-Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Aman Anand",
    "SPOC Email ID": "place@iimb.ac.in",
    "SPOC Contact number": 9643755090.0,
  },
  {
    "Sr No": 61.0,
    "Name of university/College": "Indian Institute of Management-Kashipur",
    "College as available in SC":
      "NMIMS Mumbai - Narsee Monjee Institute of Management Studies - Mumbai",
    "Number of campuses": 1.0,
    City: "Kashipur",
    Campus: "Indian Institute of Management-Kashipur",
    "If existing in Institution master": null,
    "SPOC Name": "Hridesh  Singh ",
    "SPOC Email ID": "crm.mum@iimkashipur.ac.in",
    "SPOC Contact number": 7506017016.0,
  },
  {
    "Sr No": 62.0,
    "Name of university/College": "Indian Institute of Management-Rohtak",
    "College as available in SC":
      "NMIMS Navi Mumbai - Narsee Monjee Institute of Management Studies - Navi Mumbai",
    "Number of campuses": 1.0,
    City: "Rohtak",
    Campus: "Indian Institute of Management-Rohtak",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "placement@iimrohtak.ac.in",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 63.0,
    "Name of university/College":
      "Indian Institute of Management-Tiruchirappalli",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Tiruchirappalli",
    Campus: "Indian Institute of Management, Tiruchirappalli",
    "If existing in Institution master": null,
    "SPOC Name": "Manya Bambi ",
    "SPOC Email ID": "sajid.s@iimtrichy.ac.in",
    "SPOC Contact number": "9821986646 ",
  },
  {
    "Sr No": 64.0,
    "Name of university/College": "Indian Institute of Management-Udaipur",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Udaipur",
    Campus: "Indian Institute of Management-Udaipur",
    "If existing in Institution master": null,
    "SPOC Name": "Anuja Zanzad",
    "SPOC Email ID": "anuja.zanzad@iimu.ac.in",
    "SPOC Contact number": 9860295149.0,
  },
  {
    "Sr No": 65.0,
    "Name of university/College":
      "Indian Institute of Management-Visakhapatnam",
    "College as available in SC":
      "NIBM Pune - National Institute of Bank Management - Pune",
    "Number of campuses": 1.0,
    City: "Visakhapatnam",
    Campus: "Indian Institute of Management-Visakhapatnam",
    "If existing in Institution master": null,
    "SPOC Name": "Somashekara",
    "SPOC Email ID": "place@iimv.ac.in",
    "SPOC Contact number": 9844757145.0,
  },
  {
    "Sr No": 66.0,
    "Name of university/College":
      "Indira Institute of Business Management (IIBM)",
    "College as available in SC": "NU Ahemadabad - Nirma University, Ahmedabad",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "IIBM Pune -  Indira Institute of Business Management - Pune",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 67.0,
    "Name of university/College": "Indus Business Academy (IBA)",
    "College as available in SC":
      "PDEU Raysan - Pandit Deendayal Energy University - Raysan",
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus: "IBA Bangalore - Indus Business Academy - Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 68.0,
    "Name of university/College":
      "Institute for Financial Management and Research  ( IFMR)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Chennai",
    Campus:
      "IFMR Chennai - Institute for Financial Management and Research -  Chennai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 69.0,
    "Name of university/College":
      "Institute of Finance and International Management Business School (IFIMBS)",
    "College as available in SC":
      "SPJIMR Mumbai- S. P. Jain Institute of Management and Research Mumbai",
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus:
      "IFIMBS Bangalore - Institute of Finance and International Management Business School - Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 70.0,
    "Name of university/College": "Institute of Management Studies  (IMS)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Ghaziabad",
    Campus: "IMS Ghaziabad - Institute of Management Studies - Ghaziabad",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 71.0,
    "Name of university/College": "Institute of Management Technology",
    "College as available in SC":
      "Sydenham Institute of Management Studies Research and Entrepreneurship Education, Mumbai",
    "Number of campuses": 3.0,
    City: "Ghaziabad",
    Campus: "Institute of Management Technology-Ghaziabad",
    "If existing in Institution master": null,
    "SPOC Name": "Mohit Ahuja",
    "SPOC Email ID": "emplacement@imt.edu",
    "SPOC Contact number": 9810310479.0,
  },
  {
    "Sr No": 72.0,
    "Name of university/College": "Institute of Management Technology",
    "College as available in SC":
      "SCMHRD Pune- Symbiosis Centre for Management and Human Resource Development Pune",
    "Number of campuses": null,
    City: "Hyderabad",
    Campus: "Institute of Management Technology-Hyderabad",
    "If existing in Institution master": null,
    "SPOC Name": "Sowjanya",
    "SPOC Email ID": "cro@imthyderabad.edu.in",
    "SPOC Contact number": 6301735317.0,
  },
  {
    "Sr No": 73.0,
    "Name of university/College": "Institute of Management Technology",
    "College as available in SC":
      "SIBM Bangalore- Symbiosis Institute of Business Management, Bengaluru",
    "Number of campuses": null,
    City: "Nagpur",
    Campus: "Institute of Management Technology-Nagpur",
    "If existing in Institution master": null,
    "SPOC Name": "Venkat Sai",
    "SPOC Email ID": "vsai@imtnag.ac.in",
    "SPOC Contact number": 9849503169.0,
  },
  {
    "Sr No": 74.0,
    "Name of university/College": "Institute of Public Enterprise  (IPE)",
    "College as available in SC": "SIBM-Hyderabad",
    "Number of campuses": 1.0,
    City: "Hyderabad",
    Campus: "IPE Hyderabad - Institute of Public Enterprise - Hyderabad",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 75.0,
    "Name of university/College": "Institute of Rural Management Anand",
    "College as available in SC": "SIBM-Nagpur",
    "Number of campuses": 1.0,
    City: "Anand",
    Campus: "Institute of Rural Management Anand",
    "If existing in Institution master": null,
    "SPOC Name": "Alpesh",
    "SPOC Email ID": "placementcell@irma.ac.in/ placementcell41@irma.ac.in",
    "SPOC Contact number": 7069066175.0,
  },
  {
    "Sr No": 76.0,
    "Name of university/College": "International Management Institute (IMI)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "IMI Kolkata - International Management Institute - Kolkata",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 77.0,
    "Name of university/College": "International School of Business and Media",
    "College as available in SC":
      "SSBF Pune - Symbiosis School of Banking and Finance - Pune",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "International School of Business and Media - Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Aliva Mohanty",
    "SPOC Email ID": "icare@isbm.ac.in , icarecell@isbm.ac.in",
    "SPOC Contact number": "86690 36316 ",
  },
  {
    "Sr No": 78.0,
    "Name of university/College": "ITM Business School",
    "College as available in SC": null,
    "Number of campuses": 2.0,
    City: "Mumbai",
    Campus: "ITM Business School-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Seema",
    "SPOC Email ID": "seeman@itm.edu",
    "SPOC Contact number": 9820372190.0,
  },
  {
    "Sr No": 79.0,
    "Name of university/College": "ITM Business School",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Chennai",
    Campus: "ITM Business School-Chennai",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 80.0,
    "Name of university/College": "Jain University",
    "College as available in SC":
      "TIET Patiala - Thapar Institute of Engineering and Technology - Patiala",
    "Number of campuses": 1.0,
    City: "Bangalore",
    Campus: "Jain University - Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Preeti Bhandary ",
    "SPOC Email ID": "r.preeti@jainuniversity.ac.in",
    "SPOC Contact number": 9342345677.0,
  },
  {
    "Sr No": 81.0,
    "Name of university/College": "Jaipuria Institute Of Management",
    "College as available in SC": null,
    "Number of campuses": 4.0,
    City: "Lucknow",
    Campus: "Jaipuria Institute Of Management Lucknow",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 82.0,
    "Name of university/College": "Jaipuria Institute Of Management",
    "College as available in SC":
      "UBS Raigad - Universal Business School - Karjat",
    "Number of campuses": null,
    City: "Indore",
    Campus: "Jaipuria Institute of Management(JIMI)-Indore",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 83.0,
    "Name of university/College": "Jaipuria Institute Of Management",
    "College as available in SC":
      "UBS Chandigarh - University Business School - Chandigarh",
    "Number of campuses": null,
    City: "Jaipur",
    Campus: "Jaipuria Institute of Management-Jaipur",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 84.0,
    "Name of university/College": "Jaipuria Institute Of Management",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Noida",
    Campus: "Jaipuria Institute of Management-Noida",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 85.0,
    "Name of university/College":
      "Jamnalal Bajaj Institute of Management Studies - Mumbai",
    "College as available in SC":
      "WE School Mumbai- Welingkar Institute of Management Development and Research Mumbai",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Jamnalal Bajaj Institute of Management Studies - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Shravan Mohite",
    "SPOC Email ID": "placements@jbims.edu",
    "SPOC Contact number": "98673 81522",
  },
  {
    "Sr No": 86.0,
    "Name of university/College":
      "Kirloskar Institute of Advanced Management Studies",
    "College as available in SC":
      "XIMR Mumbai -  Xavier Institute of Management Research - Mumbai",
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "Kirloskar Institute of Advanced Management Studies-Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Rajesh Dixit",
    "SPOC Email ID": "rajesh.dixit@kiams.ac.in",
    "SPOC Contact number": 9845201800.0,
  },
  {
    "Sr No": 87.0,
    "Name of university/College":
      "KJ Somaiya Institute of Management Studies and Research-Mumbai",
    "College as available in SC":
      "XISS Ranchi - Xavier Institute of Social Service - Ranchi",
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "KJ Somaiya Institute of Management Studies and Research Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Abhijit Ambre",
    "SPOC Email ID": "abhijit.a@somaiya.edu",
    "SPOC Contact number": 8452052725.0,
  },
  {
    "Sr No": 88.0,
    "Name of university/College": "Lal Bahadur Shastri Institute Of Management",
    "College as available in SC":
      "XLRI Jamshedpur- XLRI - Xavier School of Management Jamshedpur",
    "Number of campuses": 1.0,
    City: "Delhi",
    Campus: "Lal Bahadur Shastri Institute Of Management-Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Himanshi Aneja",
    "SPOC Email ID": "placementcell@lbsim.ac.in",
    "SPOC Contact number": 9306596254.0,
  },
  {
    "Sr No": 89.0,
    "Name of university/College": "LOVELY PROFESSIONAL UNIVERSITY",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "PHAGWARA",
    Campus: "LOVELY PROFESSIONAL UNIVERSITY - PHAGWARA",
    "If existing in Institution master": null,
    "SPOC Name": "Kundan",
    "SPOC Email ID": "deepa.birje@lpu.co.in",
    "SPOC Contact number": 9401810720.0,
  },
  {
    "Sr No": 90.0,
    "Name of university/College": "Loyola Institute of Business Administration",
    "College as available in SC":
      "XSRM Bhubaneswar - Xavier School of Rural Management - Bhubaneswar",
    "Number of campuses": 1.0,
    City: "Chennai",
    Campus: "Loyola Institute of Business Administration - Chennai",
    "If existing in Institution master": null,
    "SPOC Name": "Franklin Desider P",
    "SPOC Email ID": "placement@liba.edu",
    "SPOC Contact number": 8870735023.0,
  },
  {
    "Sr No": 91.0,
    "Name of university/College": "Management Development Institute",
    "College as available in SC": null,
    "Number of campuses": 2.0,
    City: "Gurgaon",
    Campus: "Management Development Institute- Gurgaon",
    "If existing in Institution master": null,
    "SPOC Name": "Poorva sharma",
    "SPOC Email ID": "placement@mdi.ac.in",
    "SPOC Contact number": 9165514555.0,
  },
  {
    "Sr No": 92.0,
    "Name of university/College": "Management Development Institute",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Murshidabad",
    Campus: "Management Development Institute-Murshidabad",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 93.0,
    "Name of university/College":
      "Mukesh Patel School of Technology Management and Engineering",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "Mukesh Patel School of Technology Management and Engineering-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Jennifer Hillo",
    "SPOC Email ID": "Jennifer.Hilloo@nmims.edu",
    "SPOC Contact number": 9820886082.0,
  },
  {
    "Sr No": 94.0,
    "Name of university/College":
      "Mumbai Educational Trust Institute Of Management (METIOM)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Mumbai Educational Trust Institute Of Management (METIOM)-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 95.0,
    "Name of university/College":
      "N. L. Dalmia Institute of Management Studies and Research ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "NLDIMSR Mumbai - N. L. Dalmia Institute of Management Studies and Research - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 96.0,
    "Name of university/College":
      "Narsee Monjee Institute of Management Studies",
    "College as available in SC": null,
    "Number of campuses": 5.0,
    City: "Bangalore",
    Campus:
      "Narsee Monjee Institute of Management Studies- Bangalore (off Bannerghatta Road)",
    "If existing in Institution master": null,
    "SPOC Name": "Shobha Pai",
    "SPOC Email ID": "Shobha.Pai@nmims.edu",
    "SPOC Contact number": 9821474747.0,
  },
  {
    "Sr No": 97.0,
    "Name of university/College":
      "Narsee Monjee Institute of Management Studies",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Mumbai",
    Campus:
      "Narsee Monjee Institute of Management Studies- Mumbai (Vile Parle)",
    "If existing in Institution master": null,
    "SPOC Name": "Shobha Pai",
    "SPOC Email ID": "Shobha.Pai@nmims.edu",
    "SPOC Contact number": 9821474747.0,
  },
  {
    "Sr No": 98.0,
    "Name of university/College":
      "Narsee Monjee Institute of Management Studies",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "mumbai",
    Campus:
      "Narsee Monjee Institute of Management Studies- Navi Mumbai (Kharghar)",
    "If existing in Institution master": null,
    "SPOC Name": "Shobha Pai",
    "SPOC Email ID": "Shobha.Pai@nmims.edu",
    "SPOC Contact number": 9821474747.0,
  },
  {
    "Sr No": 99.0,
    "Name of university/College":
      "Narsee Monjee Institute of Management Studies",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Indore",
    Campus:
      "Narsee Monjee Institute of Management Studies- Indore (Gandhi Nagar Indore)",
    "If existing in Institution master": null,
    "SPOC Name": "Shobha Pai",
    "SPOC Email ID": "Shobha.Pai@nmims.edu",
    "SPOC Contact number": 9821474747.0,
  },
  {
    "Sr No": 100.0,
    "Name of university/College":
      "Narsee Monjee Institute of Management Studies",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Hyderabad",
    Campus:
      "Narsee Monjee Institute of Management Studies- Hyderabad (TSIIC Jadcherla Mahbubnagar)",
    "If existing in Institution master": null,
    "SPOC Name": "Shobha Pai",
    "SPOC Email ID": "Shobha.Pai@nmims.edu",
    "SPOC Contact number": 9821474747.0,
  },
  {
    "Sr No": 101.0,
    "Name of university/College":
      "National Institute of Agricultural Extension Management  (NIAEM)",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Hyderabad",
    Campus:
      "NIAEM Hyderabad - National Institute of Agricultural Extension Management - Hyderabad",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 102.0,
    "Name of university/College": "National Institute of Bank Management",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "National Institute of Bank Management-Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Naman Advani",
    "SPOC Email ID": "pgdm_placements@nibmindia.org",
    "SPOC Contact number": 8602405085.0,
  },
  {
    "Sr No": 103.0,
    "Name of university/College":
      "National Institute of Industrial Engineering ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "NITIE Mumbai- National Institute of Industrial Engineering Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 104.0,
    "Name of university/College": "NIRMA University",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Ahmedabad",
    Campus: "NIRMA University-Ahmedabad",
    "If existing in Institution master": null,
    "SPOC Name": "Neeraj Arora",
    "SPOC Email ID": "narora@nirmauni.ac.in",
    "SPOC Contact number": 9825320605.0,
  },
  {
    "Sr No": 105.0,
    "Name of university/College": "Pandit Deendayal Energy University - Raysan",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Gandhinagar",
    Campus: "Pandit Deendayal Energy University - Gandhinagar",
    "If existing in Institution master": null,
    "SPOC Name": "Kunal Lalwani",
    "SPOC Email ID": "Kunal.Lalwani@pdpu.ac.in",
    "SPOC Contact number": 9909428019.0,
  },
  {
    "Sr No": 106.0,
    "Name of university/College":
      "Pillai Institute of Management Studies and Research",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "Pillai Institute of Management Studies and Research-Navi Mumbai (Panvel)",
    "If existing in Institution master": null,
    "SPOC Name": "Gursharan Kaur",
    "SPOC Email ID": "gursharankaur@mes.ac.in",
    "SPOC Contact number": 9987732671.0,
  },
  {
    "Sr No": 107.0,
    "Name of university/College":
      "S. P. Jain Institute of Management and Research",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "S. P. Jain Institute of Management and Research-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "ARNAV CHAUHAN",
    "SPOC Email ID": "pgp22.arnav@spjimr.org",
    "SPOC Contact number": 9871229155.0,
  },
  {
    "Sr No": 108.0,
    "Name of university/College": "Shanti Business School",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Ahmedabad",
    Campus: "Shanti Business School-Ahmedabad",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "kartik@shantibschool.edu.in",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 109.0,
    "Name of university/College": "SJMSOM ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "SJMSOM Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 110.0,
    "Name of university/College": "St. Xavier's University ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "SXUK Kolkata - St. Xavier's University - Kolkata",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 111.0,
    "Name of university/College":
      "Sydenham Institute of Management Studies Research and Entrepreneurship Education",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "Sydenham Institute of Management Studies Research and Entrepreneurship Education, Mumbai-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Denzil Dsouza",
    "SPOC Email ID": "placements.simsree@gmail.com",
    "SPOC Contact number": 8454066388.0,
  },
  {
    "Sr No": 112.0,
    "Name of university/College":
      "Symbiosis Centre for Management and Human Resource Development",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Pune",
    Campus:
      "Symbiosis Centre for Management and Human Resource Development-Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Abhishek Snehi",
    "SPOC Email ID": "placements@scmhrd.edu",
    "SPOC Contact number": 7979902754.0,
  },
  {
    "Sr No": 113.0,
    "Name of university/College": "Symbiosis Institute of Business Management",
    "College as available in SC": null,
    "Number of campuses": 4.0,
    City: "Bangalore",
    Campus: "Symbiosis Institute of Business Management-Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 114.0,
    "Name of university/College": "Symbiosis Institute of Business Management",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Hyderabad",
    Campus: "Symbiosis Institute of Business Management-Hyderabad",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "cr@sibmhyd.edu.in",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 115.0,
    "Name of university/College": "Symbiosis Institute of Business Management",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Nagpur",
    Campus: "Symbiosis Institute of Business Management-Nagpur",
    "If existing in Institution master": null,
    "SPOC Name": "-",
    "SPOC Email ID": "-",
    "SPOC Contact number": "-",
  },
  {
    "Sr No": 116.0,
    "Name of university/College": "Symbiosis Institute of Business Management",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Pune",
    Campus: "Symbiosis Institute of Business Management-Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Akash Patel",
    "SPOC Email ID": "placements9@sibmpune.edu.in",
    "SPOC Contact number": 7208507659.0,
  },
  {
    "Sr No": 117.0,
    "Name of university/College":
      "Symbiosis Institute of International Business ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "SIIB Pune- Symbiosis Institute of International Business Pune",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 118.0,
    "Name of university/College": "Symbiosis School of Banking and Finance",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Pune",
    Campus: "Symbiosis School of Banking and Finance - Pune",
    "If existing in Institution master": null,
    "SPOC Name": "Mr. Aman Jain ",
    "SPOC Email ID": "placement@ssbf.edu.in",
    "SPOC Contact number": 7871450655.0,
  },
  {
    "Sr No": 119.0,
    "Name of university/College": "T. A. Pai Management Institute",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "mangalore",
    Campus: "T. A. Pai Management Institute-Mangalore",
    "If existing in Institution master": null,
    "SPOC Name": "Mandavi Gupta ",
    "SPOC Email ID": "engage.tapmi@manipal.edu",
    "SPOC Contact number": 9098030759.0,
  },
  {
    "Sr No": 120.0,
    "Name of university/College": "Tata Institute of Social Sciences",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Tata Institute of Social Sciences-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Aditi Singh",
    "SPOC Email ID": "placements.hrmlr@tiss.edu",
    "SPOC Contact number": "89899 33951",
  },
  {
    "Sr No": 121.0,
    "Name of university/College":
      "Thakur Institute Of Management Studies Research",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Thakur Institute Of Management Studies Research-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 122.0,
    "Name of university/College":
      "Thapar Institute of Engineering and Technology",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Patiala",
    Campus: "Thapar Institute of Engineering and Technology - Patiala",
    "If existing in Institution master": null,
    "SPOC Name": "Navdeep Singh",
    "SPOC Email ID": "navdeep.singh@thapar.edu",
    "SPOC Contact number": 9654003337.0,
  },
  {
    "Sr No": 123.0,
    "Name of university/College": "Thiagarajar School of Management",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Madurai",
    Campus: "Thiagarajar School of Management-Madurai",
    "If existing in Institution master": null,
    "SPOC Name": "Purushothaman G",
    "SPOC Email ID": "placement@tsm.ac.in",
    "SPOC Contact number": 9597022744.0,
  },
  {
    "Sr No": 124.0,
    "Name of university/College": "Universal Business School",
    "College as available in SC": null,
    "Number of campuses": 2.0,
    City: "Raigad",
    Campus: "Universal Business School - Raigad",
    "If existing in Institution master": null,
    "SPOC Name": "G. Suman",
    "SPOC Email ID": "gsuman@ubs.org.in",
    "SPOC Contact number": 9820993114.0,
  },
  {
    "Sr No": 125.0,
    "Name of university/College": "Universal Business School",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Chandigarh",
    Campus: "University Business School - Chandigarh",
    "If existing in Institution master": null,
    "SPOC Name": "Manjusha",
    "SPOC Email ID": "ubsplac@pu.ac.in",
    "SPOC Contact number": 9888689401.0,
  },
  {
    "Sr No": 126.0,
    "Name of university/College": "UWBS ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kolkata",
    Campus: "UWBS Kolkata",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 127.0,
    "Name of university/College": "Vedica Scholars",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Delhi",
    Campus: "Vedica Scholars-Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Deepa Kumar",
    "SPOC Email ID": "deepakumar@vedicascholars.com",
    "SPOC Contact number": 8585988988.0,
  },
  {
    "Sr No": 128.0,
    "Name of university/College": "VGSOM ",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Kharagpur",
    Campus: "VGSOM Kharagpur",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 129.0,
    "Name of university/College":
      "Vivekanand Education Society's Institute of Technology",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "VESIT Mumbai - Vivekanand Education Society's Institute of Technology, Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 130.0,
    "Name of university/College":
      "Welingkar Institute of Management Development and Research",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus:
      "Welingkar Institute of Management Development and Research Mumbai-Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Nameeta S Vaalanj",
    "SPOC Email ID": "nameeta.vaalanj@welingkar.org",
    "SPOC Contact number": 9930746467.0,
  },
  {
    "Sr No": 131.0,
    "Name of university/College":
      "Xavier Institute of Management and Entrepreneurship",
    "College as available in SC": null,
    "Number of campuses": 3.0,
    City: "Bangalore",
    Campus:
      "XIME Bangalore- Xavier Institute of Management and Entrepreneurship Bangalore",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 132.0,
    "Name of university/College":
      "Xavier Institute of Management and Entrepreneurship",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Chennai",
    Campus:
      "XIME Chennai - Xavier Institute of Management and Entrepreneurship - Chennai",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 133.0,
    "Name of university/College":
      "Xavier Institute of Management and Entrepreneurship",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Kochi",
    Campus:
      "XIME Kochi - Xavier Institute of Management and Entrepreneurship - Kochi",
    "If existing in Institution master": null,
    "SPOC Name": null,
    "SPOC Email ID": null,
    "SPOC Contact number": null,
  },
  {
    "Sr No": 134.0,
    "Name of university/College": "Xavier Institute of Management Research",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Mumbai",
    Campus: "Xavier Institute of Management Research - Mumbai",
    "If existing in Institution master": null,
    "SPOC Name": "Neeta Jadhav",
    "SPOC Email ID": "neeta@ximr.ac.in",
    "SPOC Contact number": 9920375865.0,
  },
  {
    "Sr No": 135.0,
    "Name of university/College": "Xavier Institute of Social Service",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Ranchi",
    Campus: "Xavier Institute of Social Service - Ranchi",
    "If existing in Institution master": null,
    "SPOC Name": "Aditi Mehrotra",
    "SPOC Email ID": "aditimehrotra@xiss.ac.in",
    "SPOC Contact number": 9470193056.0,
  },
  {
    "Sr No": 136.0,
    "Name of university/College": "Xavier School of Management",
    "College as available in SC": null,
    "Number of campuses": 2.0,
    City: "Jamshedpur",
    Campus: "Xavier School of Management-Jamshedpur",
    "If existing in Institution master": null,
    "SPOC Name": "Nandagopal V",
    "SPOC Email ID": "placement@xlri.ac.in",
    "SPOC Contact number": 7240365888.0,
  },
  {
    "Sr No": 137.0,
    "Name of university/College": "Xavier School of Management",
    "College as available in SC": null,
    "Number of campuses": null,
    City: "Delhi",
    Campus: "Xavier School of Management-Delhi",
    "If existing in Institution master": null,
    "SPOC Name": "Nandagopal V",
    "SPOC Email ID": "placement@xlri.ac.in",
    "SPOC Contact number": 7240365888.0,
  },
  {
    "Sr No": 138.0,
    "Name of university/College": "Xavier School of Rural Management",
    "College as available in SC": null,
    "Number of campuses": 1.0,
    City: "Bhubaneswar",
    Campus: "Xavier School of Rural Management - Bhubaneswar",
    "If existing in Institution master": null,
    "SPOC Name": "Akanshya Mishra",
    "SPOC Email ID": "srm_cas@xim.edu.in",
    "SPOC Contact number": 7894246774.0,
  },

  {
    "Sr no": 1.0,
    "Name of university/College": "Amity Global Business School",
    City: "Kochin",
    Campus: "Amity Global Business School -Kochi",
  },
  {
    "Sr no": 2.0,
    "Name of university/College": "Amity Global Business School",
    City: "Noida",
    Campus: "Amity Global Business School - Noida",
  },
  {
    "Sr no": 3.0,
    "Name of university/College": "Anand Institute Of Management",
    City: "Anand",
    Campus: "Anand Institute of Management",
  },
  {
    "Sr no": 4.0,
    "Name of university/College": "Asia-Pacific Institute Of Management",
    City: "New Delhi",
    Campus: "Asia-Pacific Institute of Management",
  },
  {
    "Sr no": 5.0,
    "Name of university/College": "Birla Institute Of Technology - Mesra",
    City: "Ranchi",
    Campus: "Birla Institute of Technology - Mesra (Ranchi)",
  },
  {
    "Sr no": 6.0,
    "Name of university/College": "Savitribai Phule Pune University",
    City: "Pune",
    Campus: "Savitribai Phule Pune University",
  },
  {
    "Sr no": 7.0,
    "Name of university/College": "CMS business school",
    City: "Bangalore",
    Campus: "CMS Business School - Bangalore",
  },
  {
    "Sr no": 8.0,
    "Name of university/College": "CMS business school",
    City: "Bangalore",
    Campus: "CMS Business School - Bangalore",
  },
  {
    "Sr no": 9.0,
    "Name of university/College": "GL Bajaj Institute Of Management and Research",
    City: "Noida",
    Campus: "GL Bajaj Institute Of Management and Research",
  },
  {
    "Sr no": 10.0,
    "Name of university/College": "GNVS Institute Of Management",
    City: "Mumbai",
    Campus: "GNVS Institute Of Management",
  },
  {
    "Sr no": 11.0,
    "Name of university/College": "Indian Institute of Management - Raipur",
    City: "Raipur",
    Campus: "Indian Institute of Management - Raipur",
  },
  {
    "Sr no": 12.0,
    "Name of university/College": "Indian Institute of Technology - Kharagpur",
    City: "Kharagpur",
    Campus: "Indian Institute of Technology - Kharagpur",
  },
  {
    "Sr no": 13.0,
    "Name of university/College": "Indian Institute Of Technology - Mumbai",
    City: "Mumbai",
    Campus: "Indian Institute Of Technology - Mumbai",
  },
  {
    "Sr no": 14.0,
    "Name of university/College": "National Institute Of Technology",
    City: "Calicut",
    Campus: "National Institute Of Technology - Calicut",
  },
  {
    "Sr no": 18.0,
    "Name of university/College": "DSF - School Of Data Science and Forecasting",
    City: "Indore",
    Campus: "DSF- School of Data Science and Forecasting - Indore",
  },
  {
    "Sr no": 19.0,
    "Name of university/College": "SIES - College Of Management Studies",
    City: "Thane",
    Campus: "SIES - College of Management Studies",
  },
  {
    "Sr no": 20.0,
    "Name of university/College": "St Xaviers Degree College",
    City: "Kozhikode",
    Campus: "St Xaviers Degree College",
  },
  {
    "Sr no": 21.0,
    "Name of university/College": "Universal Business School",
    City: "Mumbai",
    Campus: "Universal Business School - Mumbai",
  },
  {
    "Sr no": 22.0,
    "Name of university/College": "Savitribai phule pune university",
    City: "Pune",
    Campus: "Savitribai Phule Pune University",
  },
  {
    "Sr no": 26.0,
    "Name of university/College": "Indian Institute Of Technology - Kharagpur",
    City: "Kharagpur",
    Campus: "Indian Institute of Technology - Kharagpur",
  },
  {
    "Sr no": 27.0,
    "Name of university/College": "Xavier Institute Of Labor Realtions (XLRI)",
    City: "Jamshedpur",
    Campus: "Xavier Institute of Labor Realtions (XLRI) Jamshedpur",
  },
  {
    "Sr no": 28.0,
    "Name of university/College": "Xavier School Of Human Resource Management",
    City: "Bhubaneswar",
    Campus: "Xavier School of Human Resource Management - Bhubaneswar",
  },
  {
    "Sr no": 29.0,
    "Name of university/College": "Xavier School Of Human Resource Management",
    City: "Bhubaneswar",
    Campus: "Xavier School of Human Resource Management - Bhubaneswar",
  },
  {
    "Sr no": 30.0,
    "Name of university/College": "Xavier Institute Of Research And Technology",
    City: "BANGALORE",
    Campus: "Xavier Institute of Research And Technology - Bangalore",
  },
  {
    "Sr no": 31.0,
    "Name of university/College": "Xavier School Of Human Resource Management",
    City: "Bhubaneswar",
    Campus: "Xavier School of Human Resource Management - Bhubaneswar",
  },
  {
    "Sr no": 32.0,
    "Name of university/College": "Xavier Institute Of Labor Realtions (XLRI)",
    City: "Jamshedpur",
    Campus: "Xavier Institute of Labor Realtions (XLRI) Jamshedpur",
  },
  {
    "Sr no": 33.0,
    "Name of university/College": "XLRI Xavier School Of Management",
    City: "Delhi",
    Campus: "XLRI School of Management Studies - New Delhi",
  },
  {
    "Sr no": 34.0,
    "Name of university/College": "XLRI Xavier School Of Management",
    City: "Jamshedpur",
    Campus: "XLRI School of Management Studies - Jamshedpur",
  },
  {
    "Sr no": 35.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Goa",
    Campus: "Birla Institute Of Technology and Science - Pilani (Goa)",
  },
  {
    "Sr no": 36.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Hyderabad",
    Campus: "Birla Institute Of Technology and Science - Pilani  (Hyderabad)",
  },
  {
    "Sr no": 37.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Pilani",
    Campus:
      "Birla Institute Of Technology and Science - Pilani  (Pilani - Rajasthan)",
  },
];

export const engColleges=[
  {
    "Sr no": 35.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Goa",
    Campus: "Birla Institute Of Technology and Science - Pilani (Goa)",
  },
  {
    "Sr no": 36.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Hyderabad",
    Campus: "Birla Institute Of Technology and Science - Pilani  (Hyderabad)",
  },
  {
    "Sr no": 37.0,
    "Name of university/College":
      "Birla Institute Of Technology and Science - Pilani",
    City: "Pilani",
    Campus:
      "Birla Institute Of Technology and Science - Pilani  (Pilani - Rajasthan)",
  },
 {
  "Synergy id": 633624,
  "Synergy Connect name_institution": "IIIT Delhi - Indraprastha Institute of Information Technology Delhi",
  "Name of university\/College": "Indraprastha Institute of Information Technology Delhi (IIIT Delhi)",
  "Campus": "Indraprastha Institute of Information Technology Delhi (IIIT Delhi)",
  "city_name_id": 632502,
  "City": "Delhi",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Delhi",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633625,
  "Synergy Connect name_institution": "Indian Institute Of Information Technology, Sri City",
  "Name of university\/College": "Indian Institute Of Information Technology",
  "Campus": "Indian Institute Of Information Technology, Sri City",
  "city_name_id": 633611,
  "City": "Sri city",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Andhra Pradesh",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633626,
  "Synergy Connect name_institution": "Jadavpur University - Kolkata",
  "Name of university\/College": "Jadavpur University - Kolkata",
  "Campus": "Jadavpur University - Kolkata",
  "city_name_id": 633613,
  "City": "Jadavpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "West Bengal",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633627,
  "Synergy Connect name_institution": "MSRIT Bangalore - M.S.Ramaiah Institute of Technology, Bangalore",
  "Name of university\/College": "M.S.Ramaiah Institute of Technology",
  "Campus": "MSRIT Bangalore - M.S.Ramaiah Institute of Technology, Bangalore",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633628,
  "Synergy Connect name_institution": "NIT Rourkela",
  "Name of university\/College": "National Institute of Technology -  Rourkela",
  "Campus": "National Institute of Technology -  Rourkela",
  "city_name_id": 633615,
  "City": "Rourkela",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Odisha",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633629,
  "Synergy Connect name_institution": "NIT Silchar",
  "Name of university\/College": "National Institute of Technology -  Silchar",
  "Campus": "National Institute of Technology -  Silchar",
  "city_name_id": 633341,
  "City": "Silchar",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Assam",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633630,
  "Synergy Connect name_institution": "NIT Warangal - National Institute of Technology - Warangal",
  "Name of university\/College": "National Institute of Technology - Warangal",
  "Campus": "National Institute of Technology - Warangal",
  "city_name_id": 633582,
  "City": "Warangal",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Telangana",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633631,
  "Synergy Connect name_institution": "PESU Bangalore - PES University - Bangalore",
  "Name of university\/College": "People's Education Society (PES) University",
  "Campus": "PESU Bangalore - PES University - Bangalore",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633632,
  "Synergy Connect name_institution": "PICT Pune - Pune Institute of Computer Technology, Pune",
  "Name of university\/College": "Pune Institute of Computer Technology",
  "Campus": "PICT Pune - Pune Institute of Computer Technology",
  "city_name_id": 633088,
  "City": "Pune",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633633,
  "Synergy Connect name_institution": "VIT Vellore - Vellore Institute of Technology, Vellore",
  "Name of university\/College": "Vellore Institute of Technology",
  "Campus": "VIT Vellore - Vellore Institute of Technology",
  "city_name_id": 633552,
  "City": "Vellore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Tamil Nadu",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633634,
  "Synergy Connect name_institution": "NIT Agartala",
  "Name of university\/College": "National Institute of Technology - Agartala",
  "Campus": "National Institute of Technology - Agartala",
  "city_name_id": 632364,
  "City": "Agartala",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Tripura",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633635,
  "Synergy Connect name_institution": "NIT Surathkal - National Institute of Technology - Surathkal",
  "Name of university\/College": "National Institute of Technology - Surathkal",
  "Campus": "National Institute of Technology - Surathkal",
  "city_name_id": 633616,
  "City": "Surathkal",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633636,
  "Synergy Connect name_institution": "NIT Trichy",
  "Name of university\/College": "National Institute of Technology - Trichy",
  "Campus": "National Institute of Technology - Trichy",
  "city_name_id": 633493,
  "City": "Trichy",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Tamil Nadu",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633637,
  "Synergy Connect name_institution": "RVÂ college-Bangalore",
  "Name of university\/College": "RV College of Engineering",
  "Campus": "RV College of Engineering - Bangalore",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633638,
  "Synergy Connect name_institution": "IIT-Kanpur",
  "Name of university\/College": "Indian Institute Of Technology - Kanpur",
  "Campus": "Indian Institute Of Technology - Kanpur",
  "city_name_id": 632629,
  "City": "Kanpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Uttar Pradesh",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633639,
  "Synergy Connect name_institution": "IIT Bombay",
  "Name of university\/College": "Indian Institute Of Technology - Bombay",
  "Campus": "Indian Institute Of Technology - Bombay",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633640,
  "Synergy Connect name_institution": "IIT-Kharagpur",
  "Name of university\/College": "Indian Institute Of Technology - Kharagpur",
  "Campus": "Indian Institute Of Technology - Kharagpur",
  "city_name_id": 632652,
  "City": "Kharagpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "West Bengal",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633641,
  "Synergy Connect name_institution": "Cambridge Institute of Technology (CIT)- Bangalore",
  "Name of university\/College": "Cambridge Institute of Technology (CIT)- Bangalore",
  "Campus": "Cambridge Institute of Technology (CIT)- Bangalore",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633642,
  "Synergy Connect name_institution": "FCRCE Mumbai - Fr. Conceicao Rodrigues College of Engineering - Mumbai",
  "Name of university\/College": "Fr. Conceicao Rodrigues College of Engineering",
  "Campus": "FCRCE Mumbai - Fr. Conceicao Rodrigues College of Engineering - Mumbai",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633643,
  "Synergy Connect name_institution": "KIIT Bhubaneswar - Kalinga Institute of Industrial Technology - Bhubaneswar",
  "Name of university\/College": "Kalinga Institute of Industrial Technology ",
  "Campus": "KIIT Bhubaneswar - Kalinga Institute of Industrial Technology - Bhubaneswar",
  "city_name_id": 632458,
  "City": "Bhubaneswar",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Odisha",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633644,
  "Synergy Connect name_institution": "KLU Guntur - Koneru Lakshmaiah Education Foundation - Guntur",
  "Name of university\/College": "Koneru Lakshmaiah Education Foundation - Guntur",
  "Campus": "KLU Guntur - Koneru Lakshmaiah Education Foundation - Guntur",
  "city_name_id": 632559,
  "City": "Guntur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Andhra Pradesh",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633645,
  "Synergy Connect name_institution": "NHEI Bengaluru - New HorizonÂ CollegeÂ of Engineering, Bengaluru",
  "Name of university\/College": "New Horizon College of Engineering",
  "Campus": "NHEI Bengaluru - New Horizon College of Engineering, Bengaluru",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633646,
  "Synergy Connect name_institution": "TCET Mumbai - ThakurÂ CollegeÂ of Engineering and Technology, Mumbai",
  "Name of university\/College": "Thakur College of Engineering and Technology",
  "Campus": "TCET Mumbai - Thakur College of Engineering and Technology, Mumbai",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633647,
  "Synergy Connect name_institution": "TIET Patiala - Thapar Institute of Engineering and Technology - Patiala",
  "Name of university\/College": "Thapar Institute of Engineering and Technology",
  "Campus": "TIET Patiala - Thapar Institute of Engineering and Technology - Patiala",
  "city_name_id": 633019,
  "City": "Patiala",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Punjab",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633648,
  "Synergy Connect name_institution": "TSEC Mumbai - Thadomal Shahani EngineeringÂ CollegeÂ - Mumbai",
  "Name of university\/College": "Thadomal Shahani Engineering College",
  "Campus": "TSEC Mumbai - Thadomal Shahani Engineering College - Mumbai",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631205
 },
 {
  "Sr No": 129.0,
  "Name of university/College":
    "Vivekanand Education Society's Institute of Technology",
  "College as available in SC": null,
  "Number of campuses": 1.0,
  City: "Mumbai",
  Campus:
    "VESIT Mumbai - Vivekanand Education Society's Institute of Technology, Mumbai",
  "If existing in Institution master": null,
  "SPOC Name": null,
  "SPOC Email ID": null,
  "SPOC Contact number": null,
},
 
 {
  "Synergy id": 633650,
  "Synergy Connect name_institution": "SFIT Mumbai - St. Francis Institute of Technology - Mumbai",
  "Name of university\/College": "St. Francis Institute of Technology",
  "Campus": "SFIT Mumbai - St. Francis Institute of Technology - Mumbai",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631205
 },
 {
  "Synergy id": 633651,
  "Synergy Connect name_institution": "IIT Hyderabad",
  "Name of university\/College": "Indian Institute Of Technology - Hyderabad",
  "Campus": "Indian Institute Of Technology - Hyderabad",
  "city_name_id": 632581,
  "City": "Hyderabad",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Telangana",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633652,
  "Synergy Connect name_institution": "IIT-Madras",
  "Name of university\/College": "Indian Institute Of Technology - Madras",
  "Campus": "Indian Institute Of Technology - Madras",
  "city_name_id": 633618,
  "City": "Madras",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Tamil Nadu",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633653,
  "Synergy Connect name_institution": "IIT-Gandhinagar",
  "Name of university\/College": "Indian Institute Of Technology - Gandhinagar",
  "Campus": "Indian Institute Of Technology - Gandhinagar",
  "city_name_id": 633619,
  "City": "Gandhinagar",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Gujarat",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633654,
  "Synergy Connect name_institution": "International Institute of Information Technology Hyderabad",
  "Name of university\/College": "International Institute of Information Technology",
  "Campus": "International Institute of Information Technology - Hyderabad",
  "city_name_id": 632581,
  "City": "Hyderabad",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Telangana",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633655,
  "Synergy Connect name_institution": "International Institute of Information Technology Bangalore",
  "Name of university\/College": "International Institute of Information Technology",
  "Campus": "International Institute of Information Technology - Bangalore",
  "city_name_id": 632419,
  "City": "Bangalore",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633656,
  "Synergy Connect name_institution": "College of Engineering, Pune",
  "Name of university\/College": "College of Engineering - Pune",
  "Campus": "College of Engineering - Pune",
  "city_name_id": 633088,
  "City": "Pune",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633657,
  "Synergy Connect name_institution": "NIT-Jamshdpur",
  "Name of university\/College": "National Institute of Technology - Jamsehdpur",
  "Campus": "National Institute of Technology - Jamsehdpur",
  "city_name_id": 632600,
  "City": "Jamshedpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Jharkhand",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633658,
  "Synergy Connect name_institution": "Visvesvaraya National Institute of Technology, Nagpur",
  "Name of university\/College": "Visvesvaraya National Institute of Technology, Nagpur",
  "Campus": "Visvesvaraya National Institute of Technology, Nagpur",
  "city_name_id": 632872,
  "City": "Nagpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633659,
  "Synergy Connect name_institution": "Visvesvaraya Technological University",
  "Name of university\/College": "Visvesvaraya Technological University",
  "Campus": "Visvesvaraya Technological University - Belgaum",
  "city_name_id": 633620,
  "City": "Belgaum",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Karnataka",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633660,
  "Synergy Connect name_institution": "National Institute of Technology, Calicut",
  "Name of university\/College": "National Institute of Technology - Calicut",
  "Campus": "National Institute of Technology - Calicut",
  "city_name_id": 633621,
  "City": "Calicut",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Kerala",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633661,
  "Synergy Connect name_institution": "Veermata Jijabai Technological Institute (VJTI, Mumbai)",
  "Name of university\/College": "Veermata Jijabai Technological Institute",
  "Campus": "Veermata Jijabai Technological Institute (VJTI, Mumbai)",
  "city_name_id": 632842,
  "City": "Mumbai",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 633663,
  "Synergy Connect name_institution": "Indian Institute of Engineering Science and Technology, Shibpur",
  "Name of university\/College": "Indian Institute of Engineering Science and Technology",
  "Campus": "Indian Institute of Engineering Science and Technology, Shibpur",
  "city_name_id": 633622,
  "City": "Shibpur",
  "created_by": "System=536746",
  "created_date": "08\/24\/2023",
  "created_on": "14:25.9",
  "status": "Y",
  "org_id": 536168,
  "state_name": "West Bengal",
  "tier_grade_name_id": 631204
 },
 {
  "Synergy id": 631206,
  "Synergy Connect name_institution": "NMIMS Mumbai - Narsee Monjee Institute of Management Studies - Mumbai",
  "Name of university\/College": "Narsee Monjee Institute of Management Studies",
  "Campus": "Narsee Monjee Institute of Management Studies- Mumbai (Vile Parle)",
  "city_name_id": 631203,
  "City": "Mumbai",
  "created_date": "08\/18\/2023",
  "created_on": "30:23.8",
  "status": "N",
  "org_id": 536168,
  "state_name": "Maharashtra",
  "tier_grade_name_id": 631204
 }
]

export const Occupations = [
  "Architect",
  "Artist",
  "Businessperson",
  "Butcher",
  "Carpenter",
  "Cashier",
  "Chef",
  "Construction worker",
  "Defense Services",
  "Dentist",
  "Designer",
  "Doctor",
  "Electrician",
  "Engineer",
  "Farmer",
  "Gardener",
  "Government Employee",
  "Hotel Manager",
  "Labourer",
  "Lawyer",
  "Librarian",
  "Mechanic",
  "Others",
  "Painter",
  "Peon",
  "Pharmacist",
  "Police Officer",
  "Private Sector Employee",
  "Retired",
  "Salesperson",
  "Scientist",
  "Self-employed",
  "Tailor",
  "Teacher",
  "Unemployed",
  "Watchman",
];

export const StateList = [
  { Masters: "Sr. No.", state: "State", city: "City" },
  { Masters: 1.0, state: "Maharashtra", city: "Achalpur" },
  { Masters: 2.0, state: "Uttar Pradesh", city: "Achhnera" },
  { Masters: 3.0, state: "Gujarat", city: "Adalaj" },
  { Masters: 4.0, state: "Telangana", city: "Adilabad" },
  { Masters: 5.0, state: "Jharkhand", city: "Adityapur" },
  { Masters: 6.0, state: "Andhra Pradesh", city: "Adoni" },
  { Masters: 7.0, state: "Kerala", city: "Adoor" },
  { Masters: 8.0, state: "West Bengal", city: "Adra" },
  { Masters: 9.0, state: "Karnataka", city: "Adyar" },
  { Masters: 10.0, state: "Karnataka", city: "Afzalpur" },
  { Masters: 11.0, state: "Tripura", city: "Agartala" },
  { Masters: 12.0, state: "Uttar Pradesh", city: "Agra" },
  { Masters: 13.0, state: "Gujarat", city: "Ahmedabad" },
  { Masters: 14.0, state: "Maharashtra", city: "Ahmednagar" },
  { Masters: 15.0, state: "Mizoram", city: "Aizawl" },
  { Masters: 16.0, state: "Rajasthan", city: "Ajmer" },
  { Masters: 17.0, state: "Maharashtra", city: "Akola" },
  { Masters: 18.0, state: "Maharashtra", city: "Akot" },
  { Masters: 19.0, state: "Kerala", city: "Alappuzha" },
  { Masters: 20.0, state: "Uttar Pradesh", city: "Aligarh" },
  {
    Masters: 21.0,
    state: "West Bengal",
    city: "AlipurdUrban Agglomerationr",
  },
  { Masters: 22.0, state: "Madhya Pradesh", city: "Alirajpur" },
  { Masters: 23.0, state: "Uttar Pradesh", city: "Allahabad" },
  { Masters: 24.0, state: "Rajasthan", city: "Alwar" },
  { Masters: 25.0, state: "Andhra Pradesh", city: "Amalapuram" },
  { Masters: 26.0, state: "Maharashtra", city: "Amalner" },
  { Masters: 27.0, state: "Maharashtra", city: "Ambejogai" },
  { Masters: 28.0, state: "Chhattisgarh", city: "Ambikapur" },
  { Masters: 29.0, state: "Maharashtra", city: "Amravati" },
  { Masters: 30.0, state: "Gujarat", city: "Amreli" },
  { Masters: 31.0, state: "Punjab", city: "Amritsar" },
  { Masters: 32.0, state: "Uttar Pradesh", city: "Amroha" },
  { Masters: 33.0, state: "Andhra Pradesh", city: "Anakapalle" },
  { Masters: 34.0, state: "Gujarat", city: "Anand" },
  { Masters: 35.0, state: "Andhra Pradesh", city: "Anantapur" },
  { Masters: 36.0, state: "Jammu and Kashmir", city: "Anantnag" },
  { Masters: 37.0, state: "Maharashtra", city: "Anjangaon" },
  { Masters: 38.0, state: "Gujarat", city: "Anjar" },
  { Masters: 39.0, state: "Gujarat", city: "Ankleshwar" },
  { Masters: 40.0, state: "Tamil Nadu", city: "Arakkonam" },
  { Masters: 41.0, state: "West Bengal", city: "Arambagh" },
  { Masters: 42.0, state: "Bihar", city: "Araria" },
  { Masters: 43.0, state: "Bihar", city: "Arrah" },
  { Masters: 44.0, state: "Karnataka", city: "Arsikere" },
  { Masters: 45.0, state: "Tamil Nadu", city: "Aruppukkottai" },
  { Masters: 46.0, state: "Maharashtra", city: "Arvi" },
  { Masters: 47.0, state: "Bihar", city: "Arwal" },
  { Masters: 48.0, state: "West Bengal", city: "Asansol" },
  { Masters: 49.0, state: "Bihar", city: "Asarganj" },
  { Masters: 50.0, state: "Madhya Pradesh", city: "Ashok Nagar" },
  { Masters: 51.0, state: "Karnataka", city: "Athni" },
  { Masters: 52.0, state: "Kerala", city: "Attingal" },
  { Masters: 53.0, state: "Bihar", city: "Aurangabad" },
  { Masters: 54.0, state: "Maharashtra", city: "Aurangabad" },
  { Masters: 55.0, state: "Uttar Pradesh", city: "Azamgarh" },
  { Masters: 56.0, state: "Bihar", city: "Bagaha" },
  { Masters: 57.0, state: "Uttarakhand", city: "Bageshwar" },
  { Masters: 58.0, state: "Haryana", city: "Bahadurgarh" },
  { Masters: 59.0, state: "West Bengal", city: "Baharampur" },
  { Masters: 60.0, state: "Uttar Pradesh", city: "Bahraich" },
  { Masters: 61.0, state: "Madhya Pradesh", city: "Balaghat" },
  { Masters: 62.0, state: "Odisha", city: "Balangir" },
  { Masters: 63.0, state: "Odisha", city: "Baleshwar Town" },
  { Masters: 64.0, state: "Karnataka", city: "Ballari" },
  { Masters: 65.0, state: "West Bengal", city: "Balurghat" },
  { Masters: 66.0, state: "Karnataka", city: "Bangalore" },
  { Masters: 67.0, state: "West Bengal", city: "Bankura" },
  { Masters: 68.0, state: "Andhra Pradesh", city: "Bapatla" },
  { Masters: 69.0, state: "Jammu and Kashmir", city: "Baramula" },
  { Masters: 70.0, state: "Odisha", city: "Barbil" },
  { Masters: 71.0, state: "Uttar Pradesh", city: "Bareilly" },
  { Masters: 72.0, state: "Odisha", city: "Bargarh" },
  { Masters: 73.0, state: "Bihar", city: "Barh" },
  { Masters: 74.0, state: "Odisha", city: "Baripada Town" },
  { Masters: 75.0, state: "Rajasthan", city: "Barmer" },
  { Masters: 76.0, state: "Punjab", city: "Barnala" },
  { Masters: 77.0, state: "Assam", city: "Barpeta" },
  { Masters: 78.0, state: "Punjab", city: "Batala" },
  { Masters: 79.0, state: "Punjab", city: "Bathinda" },
  { Masters: 80.0, state: "Bihar", city: "Begusarai" },
  { Masters: 81.0, state: "Karnataka", city: "Belagavi" },
  { Masters: 82.0, state: "Telangana", city: "Bellampalle" },
  { Masters: 83.0, state: "Tripura", city: "Belonia" },
  { Masters: 84.0, state: "Bihar", city: "Bettiah" },
  { Masters: 85.0, state: "Bihar", city: "Bhabua" },
  { Masters: 86.0, state: "Bihar", city: "BhabUrban Agglomeration" },
  { Masters: 87.0, state: "Uttar Pradesh", city: "Bhadohi" },
  { Masters: 88.0, state: "Telangana", city: "Bhadrachalam" },
  { Masters: 89.0, state: "Odisha", city: "Bhadrak" },
  { Masters: 90.0, state: "Bihar", city: "Bhagalpur" },
  { Masters: 91.0, state: "Telangana", city: "Bhainsa" },
  { Masters: 92.0, state: "Rajasthan", city: "Bharatpur" },
  { Masters: 93.0, state: "Gujarat", city: "Bharuch" },
  { Masters: 94.0, state: "Chhattisgarh", city: "Bhatapara" },
  { Masters: 95.0, state: "Gujarat", city: "Bhavnagar" },
  { Masters: 96.0, state: "Odisha", city: "Bhawanipatna" },
  { Masters: 97.0, state: "Andhra Pradesh", city: "Bheemunipatnam" },
  { Masters: 98.0, state: "Chhattisgarh", city: "Bhilai Nagar" },
  { Masters: 99.0, state: "Rajasthan", city: "Bhilwara" },
  { Masters: 100.0, state: "Andhra Pradesh", city: "Bhimavaram" },
  { Masters: 101.0, state: "Maharashtra", city: "Bhiwandi" },
  { Masters: 102.0, state: "Haryana", city: "Bhiwani" },
  { Masters: 103.0, state: "Telangana", city: "Bhongir" },
  { Masters: 104.0, state: "Madhya Pradesh", city: "Bhopal" },
  { Masters: 105.0, state: "Odisha", city: "Bhubaneswar" },
  { Masters: 106.0, state: "Gujarat", city: "Bhuj" },
  { Masters: 107.0, state: "Rajasthan", city: "Bikaner" },
  { Masters: 108.0, state: "Chhattisgarh", city: "Bilaspur" },
  { Masters: 109.0, state: "Andhra Pradesh", city: "Bobbili" },
  { Masters: 110.0, state: "Telangana", city: "Bodhan" },
  { Masters: 111.0, state: "Bihar", city: "Bodhgaya" },
  { Masters: 112.0, state: "Jharkhand", city: "Bokaro Steel City" },
  { Masters: 113.0, state: "Assam", city: "Bongaigaon City" },
  { Masters: 114.0, state: "Odisha", city: "Brahmapur" },
  { Masters: 115.0, state: "Bihar", city: "Buxar" },
  { Masters: 116.0, state: "Odisha", city: "Byasanagar" },
  { Masters: 117.0, state: "Jharkhand", city: "Chaibasa" },
  { Masters: 118.0, state: "Kerala", city: "Chalakudy" },
  { Masters: 119.0, state: "Uttar Pradesh", city: "Chandausi" },
  { Masters: 120.0, state: "Chandigarh", city: "Chandigarh" },
  { Masters: 121.0, state: "Maharashtra", city: "Chandrapur" },
  { Masters: 122.0, state: "Kerala", city: "Changanassery" },
  { Masters: 123.0, state: "Haryana", city: "Charkhi Dadri" },
  { Masters: 124.0, state: "Jharkhand", city: "Chatra" },
  { Masters: 125.0, state: "Tamil Nadu", city: "Chennai" },
  { Masters: 126.0, state: "Kerala", city: "Cherthala" },
  { Masters: 127.0, state: "Bihar", city: "Chhapra" },
  { Masters: 128.0, state: "Gujarat", city: "Chhapra" },
  { Masters: 129.0, state: "Madhya Pradesh", city: "Chhatarpur" },
  { Masters: 130.0, state: "Karnataka", city: "Chikkamagaluru" },
  { Masters: 131.0, state: "Andhra Pradesh", city: "Chilakaluripet" },
  { Masters: 132.0, state: "Maharashtra", city: "Chimur" },
  { Masters: 133.0, state: "Andhra Pradesh", city: "Chirala" },
  { Masters: 134.0, state: "Jharkhand", city: "Chirkunda" },
  { Masters: 135.0, state: "Chhattisgarh", city: "Chirmiri" },
  { Masters: 136.0, state: "Karnataka", city: "Chitradurga" },
  { Masters: 137.0, state: "Andhra Pradesh", city: "Chittoor" },
  { Masters: 138.0, state: "Kerala", city: "Chittur-Thathamangalam" },
  { Masters: 139.0, state: "Tamil Nadu", city: "Coimbatore" },
  { Masters: 140.0, state: "Odisha", city: "Cuttack" },
  { Masters: 141.0, state: "Gujarat", city: "Dahod" },
  { Masters: 142.0, state: "Chhattisgarh", city: "Dalli-Rajhara" },
  { Masters: 143.0, state: "Bihar", city: "Darbhanga" },
  { Masters: 144.0, state: "West Bengal", city: "Darjiling" },
  { Masters: 145.0, state: "Madhya Pradesh", city: "Datia" },
  { Masters: 146.0, state: "Karnataka", city: "Davanagere" },
  { Masters: 147.0, state: "Gujarat", city: "Deesa" },
  { Masters: 148.0, state: "Uttarakhand", city: "Dehradun" },
  { Masters: 149.0, state: "Bihar", city: "Dehri-on-Sone" },
  { Masters: 150.0, state: "Delhi", city: "Delhi" },
  { Masters: 151.0, state: "Jharkhand", city: "Deoghar" },
  { Masters: 152.0, state: "Uttar Pradesh", city: "Deoria" },
  { Masters: 153.0, state: "Madhya Pradesh", city: "Dewas" },
  { Masters: 154.0, state: "Chhattisgarh", city: "Dhamtari" },
  { Masters: 155.0, state: "Jharkhand", city: "Dhanbad" },
  { Masters: 156.0, state: "Tripura", city: "Dharmanagar" },
  { Masters: 157.0, state: "Andhra Pradesh", city: "Dharmavaram" },
  { Masters: 158.0, state: "Odisha", city: "Dhenkanal" },
  { Masters: 159.0, state: "Gujarat", city: "Dhoraji" },
  { Masters: 160.0, state: "Assam", city: "Dhubri" },
  { Masters: 161.0, state: "Maharashtra", city: "Dhule" },
  { Masters: 162.0, state: "Punjab", city: "Dhuri" },
  { Masters: 163.0, state: "Assam", city: "Dibrugarh" },
  { Masters: 164.0, state: "Nagaland", city: "Dimapur" },
  { Masters: 165.0, state: "Assam", city: "Diphu" },
  { Masters: 166.0, state: "Jharkhand", city: "Dumka" },
  { Masters: 167.0, state: "Bihar", city: "Dumraon" },
  { Masters: 168.0, state: "Chhattisgarh", city: "Durg" },
  { Masters: 169.0, state: "West Bengal", city: "Durgapur" },
  { Masters: 170.0, state: "Andhra Pradesh", city: "Eluru" },
  { Masters: 171.0, state: "West Bengal", city: "English Bazar" },
  { Masters: 172.0, state: "Tamil Nadu", city: "Erode" },
  { Masters: 173.0, state: "Uttar Pradesh", city: "Etawah" },
  { Masters: 174.0, state: "Uttar Pradesh", city: "Faizabad" },
  { Masters: 175.0, state: "Haryana", city: "Faridabad" },
  { Masters: 176.0, state: "Punjab", city: "Faridkot" },
  { Masters: 177.0, state: "Telangana", city: "Farooqnagar" },
  { Masters: 178.0, state: "Haryana", city: "Fatehabad" },
  { Masters: 179.0, state: "Uttar Pradesh", city: "Fatehpur Sikri" },
  { Masters: 180.0, state: "Punjab", city: "Fazilka" },
  { Masters: 181.0, state: "Uttar Pradesh", city: "Firozabad" },
  { Masters: 182.0, state: "Punjab", city: "Firozpur" },
  { Masters: 183.0, state: "Punjab", city: "Firozpur Cantt." },
  { Masters: 184.0, state: "Bihar", city: "Forbesganj" },
  { Masters: 185.0, state: "Telangana", city: "Gadwal" },
  { Masters: 186.0, state: "West Bengal", city: "Gangarampur" },
  { Masters: 187.0, state: "Madhya Pradesh", city: "Ganjbasoda" },
  { Masters: 188.0, state: "Bihar", city: "Gaya" },
  { Masters: 189.0, state: "Uttar Pradesh", city: "Ghaziabad" },
  { Masters: 190.0, state: "Jharkhand", city: "Giridih" },
  { Masters: 191.0, state: "Assam", city: "Goalpara" },
  { Masters: 192.0, state: "Tamil Nadu", city: "Gobichettipalayam" },
  { Masters: 193.0, state: "Punjab", city: "Gobindgarh" },
  { Masters: 194.0, state: "Gujarat", city: "Godhra" },
  { Masters: 195.0, state: "Haryana", city: "Gohana" },
  { Masters: 196.0, state: "Karnataka", city: "Gokak" },
  { Masters: 197.0, state: "Uttar Pradesh", city: "Gonda" },
  { Masters: 198.0, state: "Maharashtra", city: "Gondia" },
  { Masters: 199.0, state: "Andhra Pradesh", city: "Gooty" },
  { Masters: 200.0, state: "Bihar", city: "Gopalganj" },
  { Masters: 201.0, state: "Uttar Pradesh", city: "Gorakhpur" },
  { Masters: 202.0, state: "Andhra Pradesh", city: "Gudivada" },
  { Masters: 203.0, state: "Andhra Pradesh", city: "Gudur" },
  { Masters: 204.0, state: "Jharkhand", city: "Gumia" },
  { Masters: 205.0, state: "Madhya Pradesh", city: "Guna" },
  { Masters: 206.0, state: "Andhra Pradesh", city: "Guntakal" },
  { Masters: 207.0, state: "Andhra Pradesh", city: "Guntur" },
  { Masters: 208.0, state: "Punjab", city: "Gurdaspur" },
  { Masters: 209.0, state: "Haryana", city: "Gurgaon" },
  { Masters: 210.0, state: "Kerala", city: "Guruvayoor" },
  { Masters: 211.0, state: "Assam", city: "Guwahati" },
  { Masters: 212.0, state: "Madhya Pradesh", city: "Gwalior" },
  { Masters: 213.0, state: "West Bengal", city: "Habra" },
  { Masters: 214.0, state: "Bihar", city: "Hajipur" },
  {
    Masters: 215.0,
    state: "Uttarakhand",
    city: "Haldwani-cum-Kathgodam",
  },
  { Masters: 216.0, state: "Haryana", city: "Hansi" },
  { Masters: 217.0, state: "Rajasthan", city: "Hanumangarh" },
  { Masters: 218.0, state: "Uttar Pradesh", city: "Hapur" },
  { Masters: 219.0, state: "Madhya Pradesh", city: "Harda" },
  { Masters: 220.0, state: "Uttar Pradesh", city: "Hardoi" },
  { Masters: 221.0, state: "Uttarakhand", city: "Hardwar" },
  { Masters: 222.0, state: "Karnataka", city: "Hassan" },
  { Masters: 223.0, state: "Jharkhand", city: "Hazaribag" },
  { Masters: 224.0, state: "Andhra Pradesh", city: "Hindupur" },
  { Masters: 225.0, state: "Haryana", city: "Hisar" },
  { Masters: 226.0, state: "Punjab", city: "Hoshiarpur" },
  { Masters: 227.0, state: "Karnataka", city: "Hubli-Dharwad" },
  { Masters: 228.0, state: "West Bengal", city: "Hugli-Chinsurah" },
  { Masters: 229.0, state: "Telangana", city: "Hyderabad" },
  { Masters: 230.0, state: "Maharashtra", city: "Ichalkaranji" },
  { Masters: 231.0, state: "Manipur", city: "Imphal" },
  { Masters: 232.0, state: "Madhya Pradesh", city: "Indore" },
  { Masters: 233.0, state: "Madhya Pradesh", city: "Itarsi" },
  { Masters: 234.0, state: "Madhya Pradesh", city: "Jabalpur" },
  { Masters: 235.0, state: "Chhattisgarh", city: "Jagdalpur" },
  { Masters: 236.0, state: "Andhra Pradesh", city: "Jaggaiahpet" },
  { Masters: 237.0, state: "Punjab", city: "Jagraon" },
  { Masters: 238.0, state: "Telangana", city: "Jagtial" },
  { Masters: 239.0, state: "Rajasthan", city: "Jaipur" },
  { Masters: 240.0, state: "Punjab", city: "Jalandhar" },
  { Masters: 241.0, state: "Punjab", city: "Jalandhar Cantt." },
  { Masters: 242.0, state: "Maharashtra", city: "Jalgaon" },
  { Masters: 243.0, state: "West Bengal", city: "Jalpaiguri" },
  { Masters: 244.0, state: "Bihar", city: "Jamalpur" },
  { Masters: 245.0, state: "Andhra Pradesh", city: "Jammalamadugu" },
  { Masters: 246.0, state: "Jammu and Kashmir", city: "Jammu" },
  { Masters: 247.0, state: "Gujarat", city: "Jamnagar" },
  { Masters: 248.0, state: "Jharkhand", city: "Jamshedpur" },
  { Masters: 249.0, state: "Bihar", city: "Jamui" },
  { Masters: 250.0, state: "Telangana", city: "Jangaon" },
  { Masters: 251.0, state: "Odisha", city: "Jatani" },
  { Masters: 252.0, state: "Bihar", city: "Jehanabad" },
  { Masters: 253.0, state: "Rajasthan", city: "Jhalawar" },
  { Masters: 254.0, state: "Uttar Pradesh", city: "Jhansi" },
  { Masters: 255.0, state: "West Bengal", city: "Jhargram" },
  { Masters: 256.0, state: "Odisha", city: "Jharsuguda" },
  { Masters: 257.0, state: "Jharkhand", city: "Jhumri Tilaiya" },
  { Masters: 258.0, state: "Haryana", city: "Jind" },
  { Masters: 259.0, state: "Rajasthan", city: "Jodhpur" },
  { Masters: 260.0, state: "Assam", city: "Jorhat" },
  { Masters: 261.0, state: "Gujarat", city: "Junagadh" },
  { Masters: 262.0, state: "Andhra Pradesh", city: "Kadapa" },
  { Masters: 263.0, state: "Gujarat", city: "Kadi" },
  { Masters: 264.0, state: "Andhra Pradesh", city: "Kadiri" },
  { Masters: 265.0, state: "Telangana", city: "Kagaznagar" },
  { Masters: 266.0, state: "Tripura", city: "Kailasahar" },
  { Masters: 267.0, state: "Haryana", city: "Kaithal" },
  { Masters: 268.0, state: "Andhra Pradesh", city: "Kakinada" },
  { Masters: 269.0, state: "West Bengal", city: "Kalimpong" },
  { Masters: 270.0, state: "Uttar Pradesh", city: "Kalpi" },
  { Masters: 271.0, state: "Maharashtra", city: "Kalyan-Dombivali" },
  { Masters: 272.0, state: "Telangana", city: "Kamareddy" },
  { Masters: 273.0, state: "Tamil Nadu", city: "Kancheepuram" },
  { Masters: 274.0, state: "Andhra Pradesh", city: "Kandukur" },
  { Masters: 275.0, state: "Kerala", city: "Kanhangad" },
  { Masters: 276.0, state: "Kerala", city: "Kannur" },
  { Masters: 277.0, state: "Uttar Pradesh", city: "Kanpur" },
  { Masters: 278.0, state: "Gujarat", city: "Kapadvanj" },
  { Masters: 279.0, state: "Punjab", city: "Kapurthala" },
  { Masters: 280.0, state: "Puducherry", city: "Karaikal" },
  { Masters: 281.0, state: "Assam", city: "Karimganj" },
  { Masters: 282.0, state: "Telangana", city: "Karimnagar" },
  { Masters: 283.0, state: "Maharashtra", city: "Karjat" },
  { Masters: 284.0, state: "Haryana", city: "Karnal" },
  { Masters: 285.0, state: "Tamil Nadu", city: "Karur" },
  { Masters: 286.0, state: "Karnataka", city: "Karwar" },
  { Masters: 287.0, state: "Kerala", city: "Kasaragod" },
  { Masters: 288.0, state: "Uttarakhand", city: "Kashipur" },
  {
    Masters: 289.0,
    state: "Jammu and Kashmir",
    city: "KathUrban Agglomeration",
  },
  { Masters: 290.0, state: "Bihar", city: "Katihar" },
  { Masters: 291.0, state: "Andhra Pradesh", city: "Kavali" },
  { Masters: 292.0, state: "Kerala", city: "Kayamkulam" },
  { Masters: 293.0, state: "Odisha", city: "Kendrapara" },
  { Masters: 294.0, state: "Odisha", city: "Kendujhar" },
  { Masters: 295.0, state: "Gujarat", city: "Keshod" },
  { Masters: 296.0, state: "Uttar Pradesh", city: "Khair" },
  { Masters: 297.0, state: "Gujarat", city: "Khambhat" },
  { Masters: 298.0, state: "Telangana", city: "Khammam" },
  { Masters: 299.0, state: "Punjab", city: "Khanna" },
  { Masters: 300.0, state: "West Bengal", city: "Kharagpur" },
  { Masters: 301.0, state: "Punjab", city: "Kharar" },
  { Masters: 302.0, state: "Tripura", city: "Khowai" },
  { Masters: 303.0, state: "Bihar", city: "Kishanganj" },
  { Masters: 304.0, state: "Kerala", city: "Kochi" },
  { Masters: 305.0, state: "Kerala", city: "Kodungallur" },
  { Masters: 306.0, state: "Nagaland", city: "Kohima" },
  { Masters: 307.0, state: "Karnataka", city: "Kolar" },
  { Masters: 308.0, state: "Maharashtra", city: "Kolhapur" },
  { Masters: 309.0, state: "West Bengal", city: "Kolkata" },
  { Masters: 310.0, state: "Kerala", city: "Kollam" },
  { Masters: 311.0, state: "Telangana", city: "Koratla" },
  { Masters: 312.0, state: "Chhattisgarh", city: "Korba" },
  { Masters: 313.0, state: "Rajasthan", city: "Kota" },
  { Masters: 314.0, state: "Telangana", city: "Kothagudem" },
  { Masters: 315.0, state: "Punjab", city: "Kot Kapura" },
  { Masters: 316.0, state: "Kerala", city: "Kottayam" },
  { Masters: 317.0, state: "Andhra Pradesh", city: "Kovvur" },
  { Masters: 318.0, state: "Kerala", city: "Koyilandy" },
  { Masters: 319.0, state: "Kerala", city: "Kozhikode" },
  { Masters: 320.0, state: "Tamil Nadu", city: "Krishangiri" },
  { Masters: 321.0, state: "West Bengal", city: "Krishnanagar" },
  { Masters: 322.0, state: "Himachal Pradesh", city: "Kullu" },
  { Masters: 323.0, state: "Kerala", city: "Kunnamkulam" },
  { Masters: 324.0, state: "Andhra Pradesh", city: "Kurnool" },
  { Masters: 325.0, state: "Uttar Pradesh", city: "Kushinagar" },
  { Masters: 326.0, state: "Telangana", city: "Kyathampalle" },
  { Masters: 327.0, state: "Rajasthan", city: "Lachhmangarh" },
  { Masters: 328.0, state: "Rajasthan", city: "Ladnu" },
  { Masters: 329.0, state: "Haryana", city: "Ladwa" },
  { Masters: 330.0, state: "Madhya Pradesh", city: "Lahar" },
  { Masters: 331.0, state: "Uttar Pradesh", city: "Laharpur" },
  { Masters: 332.0, state: "Rajasthan", city: "Lakheri" },
  { Masters: 333.0, state: "Uttar Pradesh", city: "Lakhimpur" },
  { Masters: 334.0, state: "Bihar", city: "Lakhisarai" },
  { Masters: 335.0, state: "Karnataka", city: "Lakshmeshwar" },
  { Masters: 336.0, state: "Bihar", city: "Lalganj" },
  { Masters: 337.0, state: "Uttar Pradesh", city: "Lalganj" },
  {
    Masters: 338.0,
    state: "Uttar Pradesh",
    city: "Lal Gopalganj Nindaura",
  },
  { Masters: 339.0, state: "Tamil Nadu", city: "Lalgudi" },
  { Masters: 340.0, state: "Uttar Pradesh", city: "Lalitpur" },
  { Masters: 341.0, state: "Rajasthan", city: "Lalsot" },
  { Masters: 342.0, state: "Assam", city: "Lanka" },
  { Masters: 343.0, state: "Uttar Pradesh", city: "Lar" },
  { Masters: 344.0, state: "Gujarat", city: "Lathi" },
  { Masters: 345.0, state: "Maharashtra", city: "Latur" },
  { Masters: 346.0, state: "Manipur", city: "Lilong" },
  { Masters: 347.0, state: "Gujarat", city: "Limbdi" },
  { Masters: 348.0, state: "Karnataka", city: "Lingsugur" },
  { Masters: 349.0, state: "Maharashtra", city: "Loha" },
  { Masters: 350.0, state: "Jharkhand", city: "Lohardaga" },
  { Masters: 351.0, state: "Maharashtra", city: "Lonar" },
  { Masters: 352.0, state: "Maharashtra", city: "Lonavla" },
  { Masters: 353.0, state: "Punjab", city: "Longowal" },
  { Masters: 354.0, state: "Uttar Pradesh", city: "Loni" },
  { Masters: 355.0, state: "Rajasthan", city: "Losal" },
  { Masters: 356.0, state: "Uttar Pradesh", city: "Lucknow" },
  { Masters: 357.0, state: "Punjab", city: "Ludhiana" },
  { Masters: 358.0, state: "Assam", city: "Lumding" },
  { Masters: 359.0, state: "Gujarat", city: "Lunawada" },
  { Masters: 360.0, state: "Mizoram", city: "Lunglei" },
  { Masters: 361.0, state: "Andhra Pradesh", city: "Macherla" },
  { Masters: 362.0, state: "Andhra Pradesh", city: "Machilipatnam" },
  { Masters: 363.0, state: "Andhra Pradesh", city: "Madanapalle" },
  { Masters: 364.0, state: "Karnataka", city: "Maddur" },
  { Masters: 365.0, state: "Bihar", city: "Madhepura" },
  { Masters: 366.0, state: "Bihar", city: "Madhubani" },
  { Masters: 367.0, state: "Karnataka", city: "Madhugiri" },
  { Masters: 368.0, state: "Jharkhand", city: "Madhupur" },
  { Masters: 369.0, state: "Karnataka", city: "Madikeri" },
  { Masters: 370.0, state: "Tamil Nadu", city: "Madurai" },
  { Masters: 371.0, state: "Karnataka", city: "Magadi" },
  { Masters: 372.0, state: "Maharashtra", city: "Mahad" },
  { Masters: 373.0, state: "Karnataka", city: "Mahalingapura" },
  { Masters: 374.0, state: "Bihar", city: "Maharajganj" },
  { Masters: 375.0, state: "Madhya Pradesh", city: "Maharajpur" },
  { Masters: 376.0, state: "Chhattisgarh", city: "Mahasamund" },
  { Masters: 377.0, state: "Telangana", city: "Mahbubnagar" },
  { Masters: 378.0, state: "Puducherry", city: "Mahe" },
  { Masters: 379.0, state: "Gujarat", city: "Mahemdabad" },
  { Masters: 380.0, state: "Haryana", city: "Mahendragarh" },
  { Masters: 381.0, state: "Gujarat", city: "Mahesana" },
  { Masters: 382.0, state: "Madhya Pradesh", city: "Mahidpur" },
  { Masters: 383.0, state: "Bihar", city: "Mahnar Bazar" },
  { Masters: 384.0, state: "Gujarat", city: "Mahuva" },
  { Masters: 385.0, state: "Madhya Pradesh", city: "Maihar" },
  { Masters: 386.0, state: "West Bengal", city: "Mainaguri" },
  { Masters: 387.0, state: "Bihar", city: "Makhdumpur" },
  { Masters: 388.0, state: "Rajasthan", city: "Makrana" },
  { Masters: 389.0, state: "Madhya Pradesh", city: "Malaj Khand" },
  { Masters: 390.0, state: "Kerala", city: "Malappuram" },
  { Masters: 391.0, state: "Karnataka", city: "Malavalli" },
  { Masters: 392.0, state: "West Bengal", city: "Malda" },
  { Masters: 393.0, state: "Maharashtra", city: "Malegaon" },
  { Masters: 394.0, state: "Punjab", city: "Malerkotla" },
  { Masters: 395.0, state: "Odisha", city: "Malkangiri" },
  { Masters: 396.0, state: "Maharashtra", city: "Malkapur" },
  { Masters: 397.0, state: "Punjab", city: "Malout" },
  { Masters: 398.0, state: "Rajasthan", city: "Malpura" },
  { Masters: 399.0, state: "Karnataka", city: "Malur" },
  { Masters: 400.0, state: "Tamil Nadu", city: "Manachanallur" },
  { Masters: 401.0, state: "Madhya Pradesh", city: "Manasa" },
  { Masters: 402.0, state: "Gujarat", city: "Manavadar" },
  { Masters: 403.0, state: "Madhya Pradesh", city: "Manawar" },
  { Masters: 404.0, state: "Telangana", city: "Mancherial" },
  { Masters: 405.0, state: "Rajasthan", city: "Mandalgarh" },
  { Masters: 406.0, state: "Telangana", city: "Mandamarri" },
  { Masters: 407.0, state: "Andhra Pradesh", city: "Mandapeta" },
  { Masters: 408.0, state: "Rajasthan", city: "Mandawa" },
  { Masters: 409.0, state: "Himachal Pradesh", city: "Mandi" },
  { Masters: 410.0, state: "Haryana", city: "Mandi Dabwali" },
  { Masters: 411.0, state: "Madhya Pradesh", city: "Mandideep" },
  { Masters: 412.0, state: "Madhya Pradesh", city: "Mandla" },
  { Masters: 413.0, state: "Madhya Pradesh", city: "Mandsaur" },
  { Masters: 414.0, state: "Gujarat", city: "Mandvi" },
  { Masters: 415.0, state: "Karnataka", city: "Mandya" },
  { Masters: 416.0, state: "Chhattisgarh", city: "Manendragarh" },
  { Masters: 417.0, state: "Bihar", city: "Maner" },
  { Masters: 418.0, state: "Assam", city: "Mangaldoi" },
  { Masters: 419.0, state: "Karnataka", city: "Mangaluru" },
  { Masters: 420.0, state: "Maharashtra", city: "Mangalvedhe" },
  { Masters: 421.0, state: "Uttarakhand", city: "Manglaur" },
  { Masters: 422.0, state: "Gujarat", city: "Mangrol" },
  { Masters: 423.0, state: "Rajasthan", city: "Mangrol" },
  { Masters: 424.0, state: "Maharashtra", city: "Mangrulpir" },
  { Masters: 425.0, state: "Bihar", city: "Manihari" },
  { Masters: 426.0, state: "Maharashtra", city: "Manjlegaon" },
  { Masters: 427.0, state: "Assam", city: "Mankachar" },
  { Masters: 428.0, state: "Maharashtra", city: "Manmad" },
  { Masters: 429.0, state: "Punjab", city: "Mansa" },
  { Masters: 430.0, state: "Gujarat", city: "Mansa" },
  { Masters: 431.0, state: "Telangana", city: "Manuguru" },
  { Masters: 432.0, state: "Karnataka", city: "Manvi" },
  { Masters: 433.0, state: "Maharashtra", city: "Manwath" },
  { Masters: 434.0, state: "Goa", city: "Mapusa" },
  { Masters: 435.0, state: "Goa", city: "Margao" },
  { Masters: 436.0, state: "Assam", city: "Margherita" },
  { Masters: 437.0, state: "Bihar", city: "Marhaura" },
  { Masters: 438.0, state: "Assam", city: "Mariani" },
  { Masters: 439.0, state: "Assam", city: "Marigaon" },
  { Masters: 440.0, state: "Andhra Pradesh", city: "Markapur" },
  { Masters: 441.0, state: "Goa", city: "Marmagao" },
  { Masters: 442.0, state: "Bihar", city: "Masaurhi" },
  { Masters: 443.0, state: "West Bengal", city: "Mathabhanga" },
  { Masters: 444.0, state: "Uttar Pradesh", city: "Mathura" },
  { Masters: 445.0, state: "Kerala", city: "Mattannur" },
  { Masters: 446.0, state: "Madhya Pradesh", city: "Mauganj" },
  { Masters: 447.0, state: "Kerala", city: "Mavelikkara" },
  { Masters: 448.0, state: "Kerala", city: "Mavoor" },
  { Masters: 449.0, state: "Manipur", city: "Mayang Imphal" },
  { Masters: 450.0, state: "Telangana", city: "Medak" },
  {
    Masters: 451.0,
    state: "Jharkhand",
    city: "Medininagar (Daltonganj)",
  },
  { Masters: 452.0, state: "West Bengal", city: "Medinipur" },
  { Masters: 453.0, state: "Uttar Pradesh", city: "Meerut" },
  { Masters: 454.0, state: "Maharashtra", city: "Mehkar" },
  { Masters: 455.0, state: "West Bengal", city: "Memari" },
  { Masters: 456.0, state: "Rajasthan", city: "Merta City" },
  { Masters: 457.0, state: "Maharashtra", city: "Mhaswad" },
  { Masters: 458.0, state: "Madhya Pradesh", city: "Mhow Cantonment" },
  { Masters: 459.0, state: "Madhya Pradesh", city: "Mhowgaon" },
  { Masters: 460.0, state: "Jharkhand", city: "Mihijam" },
  { Masters: 461.0, state: "Maharashtra", city: "Mira-Bhayandar" },
  { Masters: 462.0, state: "Bihar", city: "Mirganj" },
  { Masters: 463.0, state: "Telangana", city: "Miryalaguda" },
  { Masters: 464.0, state: "Uttar Pradesh", city: "Mirzapur" },
  { Masters: 465.0, state: "Gujarat", city: "Modasa" },
  { Masters: 466.0, state: "Uttar Pradesh", city: "Modinagar" },
  { Masters: 467.0, state: "Punjab", city: "Moga" },
  { Masters: 468.0, state: "Punjab", city: "Mohali" },
  { Masters: 469.0, state: "Bihar", city: "Mokameh" },
  { Masters: 470.0, state: "Nagaland", city: "Mokokchung" },
  { Masters: 471.0, state: "West Bengal", city: "Monoharpur" },
  { Masters: 472.0, state: "Uttar Pradesh", city: "Moradabad" },
  { Masters: 473.0, state: "Madhya Pradesh", city: "Morena" },
  { Masters: 474.0, state: "Punjab", city: "Morinda, India" },
  { Masters: 475.0, state: "Maharashtra", city: "Morshi" },
  { Masters: 476.0, state: "Gujarat", city: "Morvi" },
  { Masters: 477.0, state: "Bihar", city: "Motihari" },
  { Masters: 478.0, state: "Bihar", city: "Motipur" },
  { Masters: 479.0, state: "Rajasthan", city: "Mount Abu" },
  { Masters: 480.0, state: "Karnataka", city: "Mudabidri" },
  { Masters: 481.0, state: "Karnataka", city: "Mudalagi" },
  { Masters: 482.0, state: "Karnataka", city: "Muddebihal" },
  { Masters: 483.0, state: "Karnataka", city: "Mudhol" },
  { Masters: 484.0, state: "Punjab", city: "Mukerian" },
  { Masters: 485.0, state: "Maharashtra", city: "Mukhed" },
  { Masters: 486.0, state: "Punjab", city: "Muktsar" },
  { Masters: 487.0, state: "Maharashtra", city: "Mul" },
  { Masters: 488.0, state: "Karnataka", city: "Mulbagal" },
  { Masters: 489.0, state: "Madhya Pradesh", city: "Multai" },
  { Masters: 490.0, state: "Maharashtra", city: "Mumbai" },
  { Masters: 491.0, state: "Karnataka", city: "Mundargi" },
  { Masters: 492.0, state: "Madhya Pradesh", city: "Mundi" },
  { Masters: 493.0, state: "Chhattisgarh", city: "Mungeli" },
  { Masters: 494.0, state: "Bihar", city: "Munger" },
  { Masters: 495.0, state: "Bihar", city: "Murliganj" },
  { Masters: 496.0, state: "West Bengal", city: "Murshidabad" },
  { Masters: 497.0, state: "Maharashtra", city: "Murtijapur" },
  { Masters: 498.0, state: "Madhya Pradesh", city: "Murwara (Katni)" },
  { Masters: 499.0, state: "Jharkhand", city: "Musabani" },
  { Masters: 500.0, state: "Uttarakhand", city: "Mussoorie" },
  { Masters: 501.0, state: "Kerala", city: "Muvattupuzha" },
  { Masters: 502.0, state: "Uttar Pradesh", city: "Muzaffarnagar" },
  { Masters: 503.0, state: "Bihar", city: "Muzaffarpur" },
  { Masters: 504.0, state: "Karnataka", city: "Mysore" },
  { Masters: 505.0, state: "West Bengal", city: "Nabadwip" },
  { Masters: 506.0, state: "Odisha", city: "Nabarangapur" },
  { Masters: 507.0, state: "Punjab", city: "Nabha" },
  { Masters: 508.0, state: "Rajasthan", city: "Nadbai" },
  { Masters: 509.0, state: "Gujarat", city: "Nadiad" },
  { Masters: 510.0, state: "Assam", city: "Nagaon" },
  { Masters: 511.0, state: "Tamil Nadu", city: "Nagapattinam" },
  { Masters: 512.0, state: "Rajasthan", city: "Nagar" },
  { Masters: 513.0, state: "Andhra Pradesh", city: "Nagari" },
  { Masters: 514.0, state: "Telangana", city: "Nagarkurnool" },
  { Masters: 515.0, state: "Rajasthan", city: "Nagaur" },
  { Masters: 516.0, state: "Madhya Pradesh", city: "Nagda" },
  { Masters: 517.0, state: "Tamil Nadu", city: "Nagercoil" },
  { Masters: 518.0, state: "Uttar Pradesh", city: "Nagina" },
  { Masters: 519.0, state: "Uttarakhand", city: "Nagla" },
  { Masters: 520.0, state: "Maharashtra", city: "Nagpur" },
  { Masters: 521.0, state: "Himachal Pradesh", city: "Nahan" },
  { Masters: 522.0, state: "Arunachal Pradesh", city: "Naharlagun" },
  { Masters: 523.0, state: "Andhra Pradesh", city: "Naidupet" },
  { Masters: 524.0, state: "West Bengal", city: "Naihati" },
  { Masters: 525.0, state: "Chhattisgarh", city: "Naila Janjgir" },
  { Masters: 526.0, state: "Uttarakhand", city: "Nainital" },
  { Masters: 527.0, state: "Madhya Pradesh", city: "Nainpur" },
  { Masters: 528.0, state: "Uttar Pradesh", city: "Najibabad" },
  { Masters: 529.0, state: "Punjab", city: "Nakodar" },
  { Masters: 530.0, state: "Uttar Pradesh", city: "Nakur" },
  { Masters: 531.0, state: "Assam", city: "Nalbari" },
  { Masters: 532.0, state: "Tamil Nadu", city: "Namagiripettai" },
  { Masters: 533.0, state: "Tamil Nadu", city: "Namakkal" },
  { Masters: 534.0, state: "Maharashtra", city: "Nanded-Waghala" },
  { Masters: 535.0, state: "Maharashtra", city: "Nandgaon" },
  {
    Masters: 536.0,
    state: "Tamil Nadu",
    city: "Nandivaram-Guduvancheri",
  },
  { Masters: 537.0, state: "Maharashtra", city: "Nandura" },
  { Masters: 538.0, state: "Maharashtra", city: "Nandurbar" },
  { Masters: 539.0, state: "Andhra Pradesh", city: "Nandyal" },
  { Masters: 540.0, state: "Punjab", city: "Nangal" },
  { Masters: 541.0, state: "Karnataka", city: "Nanjangud" },
  { Masters: 542.0, state: "Tamil Nadu", city: "Nanjikottai" },
  { Masters: 543.0, state: "Uttar Pradesh", city: "Nanpara" },
  { Masters: 544.0, state: "Andhra Pradesh", city: "Narasapuram" },
  { Masters: 545.0, state: "Andhra Pradesh", city: "Narasaraopet" },
  { Masters: 546.0, state: "Uttar Pradesh", city: "Naraura" },
  { Masters: 547.0, state: "Telangana", city: "Narayanpet" },
  { Masters: 548.0, state: "Karnataka", city: "Nargund" },
  { Masters: 549.0, state: "Bihar", city: "Narkatiaganj" },
  { Masters: 550.0, state: "Maharashtra", city: "Narkhed" },
  { Masters: 551.0, state: "Haryana", city: "Narnaul" },
  { Masters: 552.0, state: "Madhya Pradesh", city: "Narsinghgarh" },
  { Masters: 553.0, state: "Madhya Pradesh", city: "Narsinghgarh" },
  { Masters: 554.0, state: "Andhra Pradesh", city: "Narsipatnam" },
  { Masters: 555.0, state: "Haryana", city: "Narwana" },
  { Masters: 556.0, state: "Maharashtra", city: "Nashik" },
  { Masters: 557.0, state: "Rajasthan", city: "Nasirabad" },
  { Masters: 558.0, state: "Tamil Nadu", city: "Natham" },
  { Masters: 559.0, state: "Rajasthan", city: "Nathdwara" },
  { Masters: 560.0, state: "Bihar", city: "Naugachhia" },
  { Masters: 561.0, state: "Uttar Pradesh", city: "Naugawan Sadat" },
  { Masters: 562.0, state: "Uttar Pradesh", city: "Nautanwa" },
  { Masters: 563.0, state: "Karnataka", city: "Navalgund" },
  { Masters: 564.0, state: "Gujarat", city: "Navsari" },
  { Masters: 565.0, state: "Uttar Pradesh", city: "Nawabganj" },
  { Masters: 566.0, state: "Bihar", city: "Nawada" },
  { Masters: 567.0, state: "Punjab", city: "Nawanshahr" },
  { Masters: 568.0, state: "Maharashtra", city: "Nawapur" },
  { Masters: 569.0, state: "Kerala", city: "Nedumangad" },
  { Masters: 570.0, state: "Rajasthan", city: "Neem-Ka-Thana" },
  { Masters: 571.0, state: "Madhya Pradesh", city: "Neemuch" },
  { Masters: 572.0, state: "Uttar Pradesh", city: "Nehtaur" },
  { Masters: 573.0, state: "Karnataka", city: "Nelamangala" },
  { Masters: 574.0, state: "Tamil Nadu", city: "Nellikuppam" },
  { Masters: 575.0, state: "Andhra Pradesh", city: "Nellore" },
  { Masters: 576.0, state: "Madhya Pradesh", city: "Nepanagar" },
  { Masters: 577.0, state: "Delhi", city: "New Delhi" },
  { Masters: 578.0, state: "Tamil Nadu", city: "Neyveli (TS)" },
  { Masters: 579.0, state: "Kerala", city: "Neyyattinkara" },
  { Masters: 580.0, state: "Andhra Pradesh", city: "Nidadavole" },
  { Masters: 581.0, state: "Kerala", city: "Nilambur" },
  { Masters: 582.0, state: "Maharashtra", city: "Nilanga" },
  { Masters: 583.0, state: "Rajasthan", city: "Nimbahera" },
  { Masters: 584.0, state: "Telangana", city: "Nirmal" },
  { Masters: 585.0, state: "Uttar Pradesh", city: "Niwai" },
  { Masters: 586.0, state: "Madhya Pradesh", city: "Niwari" },
  { Masters: 587.0, state: "Telangana", city: "Nizamabad" },
  { Masters: 588.0, state: "Rajasthan", city: "Nohar" },
  { Masters: 589.0, state: "Uttar Pradesh", city: "Noida" },
  { Masters: 590.0, state: "Bihar", city: "Nokha" },
  { Masters: 591.0, state: "Rajasthan", city: "Nokha" },
  { Masters: 592.0, state: "Meghalaya", city: "Nongstoin" },
  { Masters: 593.0, state: "Uttar Pradesh", city: "Noorpur" },
  { Masters: 594.0, state: "Goa", city: "North Goa" },
  { Masters: 595.0, state: "Assam", city: "North Lakhimpur" },
  { Masters: 596.0, state: "Madhya Pradesh", city: "Nowgong" },
  {
    Masters: 597.0,
    state: "Madhya Pradesh",
    city: "Nowrozabad (Khodargama)",
  },
  { Masters: 598.0, state: "Andhra Pradesh", city: "Nuzvid" },
  { Masters: 599.0, state: "Uttar Pradesh", city: "Obra" },
  { Masters: 600.0, state: "Tamil Nadu", city: "Oddanchatram" },
  { Masters: 601.0, state: "Andhra Pradesh", city: "Ongole" },
  { Masters: 602.0, state: "Uttar Pradesh", city: "Orai" },
  { Masters: 603.0, state: "Maharashtra", city: "Osmanabad" },
  { Masters: 604.0, state: "Kerala", city: "Ottappalam" },
  { Masters: 605.0, state: "Tamil Nadu", city: "O' Valley" },
  { Masters: 606.0, state: "Maharashtra", city: "Ozar" },
  { Masters: 607.0, state: "Maharashtra", city: "Pachora" },
  { Masters: 608.0, state: "Madhya Pradesh", city: "Pachore" },
  { Masters: 609.0, state: "Tamil Nadu", city: "Pacode" },
  { Masters: 610.0, state: "Tamil Nadu", city: "Padmanabhapuram" },
  { Masters: 611.0, state: "Gujarat", city: "Padra" },
  { Masters: 612.0, state: "Uttar Pradesh", city: "Padrauna" },
  { Masters: 613.0, state: "Maharashtra", city: "Paithan" },
  { Masters: 614.0, state: "Jharkhand", city: "Pakaur" },
  { Masters: 615.0, state: "Andhra Pradesh", city: "Palacole" },
  { Masters: 616.0, state: "Kerala", city: "Palai" },
  { Masters: 617.0, state: "Kerala", city: "Palakkad" },
  { Masters: 618.0, state: "Himachal Pradesh", city: "Palampur" },
  { Masters: 619.0, state: "Tamil Nadu", city: "Palani" },
  { Masters: 620.0, state: "Gujarat", city: "Palanpur" },
  { Masters: 621.0, state: "Andhra Pradesh", city: "Palasa Kasibugga" },
  { Masters: 622.0, state: "Maharashtra", city: "Palghar" },
  { Masters: 623.0, state: "Madhya Pradesh", city: "Pali" },
  { Masters: 624.0, state: "Rajasthan", city: "Pali" },
  { Masters: 625.0, state: "Uttar Pradesh", city: "Palia Kalan" },
  { Masters: 626.0, state: "Gujarat", city: "Palitana" },
  { Masters: 627.0, state: "Tamil Nadu", city: "Palladam" },
  { Masters: 628.0, state: "Tamil Nadu", city: "Pallapatti" },
  { Masters: 629.0, state: "Tamil Nadu", city: "Pallikonda" },
  { Masters: 630.0, state: "Haryana", city: "Palwal" },
  { Masters: 631.0, state: "Telangana", city: "Palwancha" },
  { Masters: 632.0, state: "Madhya Pradesh", city: "Panagar" },
  { Masters: 633.0, state: "Tamil Nadu", city: "Panagudi" },
  { Masters: 634.0, state: "Goa", city: "Panaji" },
  { Masters: 635.0, state: "Kerala", city: "Panamattom" },
  { Masters: 636.0, state: "Haryana", city: "Panchkula" },
  { Masters: 637.0, state: "West Bengal", city: "Panchla" },
  { Masters: 638.0, state: "Maharashtra", city: "Pandharkaoda" },
  { Masters: 639.0, state: "Maharashtra", city: "Pandharpur" },
  { Masters: 640.0, state: "Madhya Pradesh", city: "Pandhurna" },
  {
    Masters: 641.0,
    state: "West Bengal",
    city: "PandUrban Agglomeration",
  },
  { Masters: 642.0, state: "Haryana", city: "Panipat" },
  { Masters: 643.0, state: "Madhya Pradesh", city: "Panna" },
  { Masters: 644.0, state: "Kerala", city: "Panniyannur" },
  { Masters: 645.0, state: "Tamil Nadu", city: "Panruti" },
  { Masters: 646.0, state: "Maharashtra", city: "Panvel" },
  { Masters: 647.0, state: "Kerala", city: "Pappinisseri" },
  { Masters: 648.0, state: "Odisha", city: "Paradip" },
  { Masters: 649.0, state: "Tamil Nadu", city: "Paramakudi" },
  { Masters: 650.0, state: "Tamil Nadu", city: "Parangipettai" },
  { Masters: 651.0, state: "Uttar Pradesh", city: "Parasi" },
  { Masters: 652.0, state: "Kerala", city: "Paravoor" },
  { Masters: 653.0, state: "Maharashtra", city: "Parbhani" },
  { Masters: 654.0, state: "Gujarat", city: "Pardi" },
  { Masters: 655.0, state: "Odisha", city: "Parlakhemundi" },
  { Masters: 656.0, state: "Maharashtra", city: "Parli" },
  { Masters: 657.0, state: "Maharashtra", city: "Partur" },
  { Masters: 658.0, state: "Andhra Pradesh", city: "Parvathipuram" },
  { Masters: 659.0, state: "Madhya Pradesh", city: "Pasan" },
  { Masters: 660.0, state: "West Bengal", city: "Paschim Punropara" },
  { Masters: 661.0, state: "Arunachal Pradesh", city: "Pasighat" },
  { Masters: 662.0, state: "Gujarat", city: "Patan" },
  { Masters: 663.0, state: "Kerala", city: "Pathanamthitta" },
  { Masters: 664.0, state: "Punjab", city: "Pathankot" },
  { Masters: 665.0, state: "Maharashtra", city: "Pathardi" },
  { Masters: 666.0, state: "Maharashtra", city: "Pathri" },
  { Masters: 667.0, state: "Punjab", city: "Patiala" },
  { Masters: 668.0, state: "Bihar", city: "Patna" },
  { Masters: 669.0, state: "Jharkhand", city: "Patratu" },
  { Masters: 670.0, state: "Odisha", city: "Pattamundai" },
  { Masters: 671.0, state: "Punjab", city: "Patti" },
  { Masters: 672.0, state: "Punjab", city: "Pattran" },
  { Masters: 673.0, state: "Tamil Nadu", city: "Pattukkottai" },
  { Masters: 674.0, state: "Maharashtra", city: "Patur" },
  { Masters: 675.0, state: "Maharashtra", city: "Pauni" },
  { Masters: 676.0, state: "Uttarakhand", city: "Pauri" },
  { Masters: 677.0, state: "Karnataka", city: "Pavagada" },
  { Masters: 678.0, state: "Andhra Pradesh", city: "Pedana" },
  { Masters: 679.0, state: "Andhra Pradesh", city: "Peddapuram" },
  { Masters: 680.0, state: "Haryana", city: "Pehowa" },
  { Masters: 681.0, state: "Maharashtra", city: "Pen" },
  { Masters: 682.0, state: "Tamil Nadu", city: "Perambalur" },
  { Masters: 683.0, state: "Tamil Nadu", city: "Peravurani" },
  { Masters: 684.0, state: "Kerala", city: "Peringathur" },
  { Masters: 685.0, state: "Kerala", city: "Perinthalmanna" },
  { Masters: 686.0, state: "Tamil Nadu", city: "Periyakulam" },
  { Masters: 687.0, state: "Tamil Nadu", city: "Periyasemur" },
  { Masters: 688.0, state: "Tamil Nadu", city: "Pernampattu" },
  { Masters: 689.0, state: "Kerala", city: "Perumbavoor" },
  { Masters: 690.0, state: "Gujarat", city: "Petlad" },
  { Masters: 691.0, state: "Punjab", city: "Phagwara" },
  { Masters: 692.0, state: "Rajasthan", city: "Phalodi" },
  { Masters: 693.0, state: "Maharashtra", city: "Phaltan" },
  { Masters: 694.0, state: "Punjab", city: "Phillaur" },
  { Masters: 695.0, state: "Odisha", city: "Phulabani" },
  { Masters: 696.0, state: "Rajasthan", city: "Phulera" },
  { Masters: 697.0, state: "Uttar Pradesh", city: "Phulpur" },
  { Masters: 698.0, state: "Jharkhand", city: "Phusro" },
  { Masters: 699.0, state: "Uttar Pradesh", city: "Pihani" },
  { Masters: 700.0, state: "Rajasthan", city: "Pilani" },
  { Masters: 701.0, state: "Rajasthan", city: "Pilibanga" },
  { Masters: 702.0, state: "Uttar Pradesh", city: "Pilibhit" },
  { Masters: 703.0, state: "Uttar Pradesh", city: "Pilkhuwa" },
  { Masters: 704.0, state: "Rajasthan", city: "Pindwara" },
  { Masters: 705.0, state: "Haryana", city: "Pinjore" },
  { Masters: 706.0, state: "Rajasthan", city: "Pipar City" },
  { Masters: 707.0, state: "Madhya Pradesh", city: "Pipariya" },
  { Masters: 708.0, state: "Karnataka", city: "Piriyapatna" },
  { Masters: 709.0, state: "Bihar", city: "Piro" },
  { Masters: 710.0, state: "Madhya Pradesh", city: "Pithampur" },
  { Masters: 711.0, state: "Andhra Pradesh", city: "Pithapuram" },
  { Masters: 712.0, state: "Uttarakhand", city: "Pithoragarh" },
  { Masters: 713.0, state: "Tamil Nadu", city: "P.N.Patti" },
  { Masters: 714.0, state: "Tamil Nadu", city: "Pollachi" },
  { Masters: 715.0, state: "Tamil Nadu", city: "Polur" },
  { Masters: 716.0, state: "Puducherry", city: "Pondicherry" },
  { Masters: 717.0, state: "Kerala", city: "Ponnani" },
  { Masters: 718.0, state: "Tamil Nadu", city: "Ponneri" },
  { Masters: 719.0, state: "Andhra Pradesh", city: "Ponnur" },
  { Masters: 720.0, state: "Gujarat", city: "Porbandar" },
  { Masters: 721.0, state: "Madhya Pradesh", city: "Porsa" },
  {
    Masters: 722.0,
    state: "Andaman and Nicobar Islands",
    city: "Port Blair",
  },
  { Masters: 723.0, state: "Uttar Pradesh", city: "Powayan" },
  { Masters: 724.0, state: "Rajasthan", city: "Prantij" },
  { Masters: 725.0, state: "Tripura", city: "Pratapgarh" },
  { Masters: 726.0, state: "Rajasthan", city: "Pratapgarh" },
  { Masters: 727.0, state: "Madhya Pradesh", city: "Prithvipur" },
  { Masters: 728.0, state: "Andhra Pradesh", city: "Proddatur" },
  { Masters: 729.0, state: "Tamil Nadu", city: "Pudukkottai" },
  { Masters: 730.0, state: "Tamil Nadu", city: "Pudupattinam" },
  { Masters: 731.0, state: "Uttar Pradesh", city: "Pukhrayan" },
  { Masters: 732.0, state: "Maharashtra", city: "Pulgaon" },
  { Masters: 733.0, state: "Tamil Nadu", city: "Puliyankudi" },
  { Masters: 734.0, state: "Kerala", city: "Punalur" },
  { Masters: 735.0, state: "Jammu and Kashmir", city: "Punch" },
  { Masters: 736.0, state: "Maharashtra", city: "Pune" },
  { Masters: 737.0, state: "Andhra Pradesh", city: "Punganur" },
  { Masters: 738.0, state: "Tamil Nadu", city: "Punjaipugalur" },
  { Masters: 739.0, state: "Uttar Pradesh", city: "Puranpur" },
  { Masters: 740.0, state: "West Bengal", city: "Purba Bardhaman" },
  { Masters: 741.0, state: "Odisha", city: "Puri" },
  { Masters: 742.0, state: "Maharashtra", city: "Purna" },
  { Masters: 743.0, state: "Bihar", city: "Purnia" },
  {
    Masters: 744.0,
    state: "Uttar Pradesh",
    city: "PurqUrban Agglomerationzi",
  },
  { Masters: 745.0, state: "West Bengal", city: "Purulia" },
  { Masters: 746.0, state: "Uttar Pradesh", city: "Purwa" },
  { Masters: 747.0, state: "Maharashtra", city: "Pusad" },
  { Masters: 748.0, state: "Kerala", city: "Puthuppally" },
  { Masters: 749.0, state: "Karnataka", city: "Puttur" },
  { Masters: 750.0, state: "Andhra Pradesh", city: "Puttur" },
  { Masters: 751.0, state: "Punjab", city: "Qadian" },
  { Masters: 752.0, state: "Karnataka", city: "Raayachuru" },
  { Masters: 753.0, state: "Karnataka", city: "Rabkavi Banhatti" },
  { Masters: 754.0, state: "Gujarat", city: "Radhanpur" },
  { Masters: 755.0, state: "Uttar Pradesh", city: "Rae Bareli" },
  { Masters: 756.0, state: "Bihar", city: "Rafiganj" },
  {
    Masters: 757.0,
    state: "Madhya Pradesh",
    city: "Raghogarh-Vijaypur",
  },
  { Masters: 758.0, state: "West Bengal", city: "Raghunathganj" },
  { Masters: 759.0, state: "West Bengal", city: "Raghunathpur" },
  { Masters: 760.0, state: "Madhya Pradesh", city: "Rahatgarh" },
  { Masters: 761.0, state: "Maharashtra", city: "Rahuri" },
  { Masters: 762.0, state: "West Bengal", city: "Raiganj" },
  { Masters: 763.0, state: "Chhattisgarh", city: "Raigarh" },
  { Masters: 764.0, state: "Punjab", city: "Raikot" },
  { Masters: 765.0, state: "Chhattisgarh", city: "Raipur" },
  { Masters: 766.0, state: "Odisha", city: "Rairangpur" },
  { Masters: 767.0, state: "Madhya Pradesh", city: "Raisen" },
  { Masters: 768.0, state: "Rajasthan", city: "Raisinghnagar" },
  { Masters: 769.0, state: "Odisha", city: "Rajagangapur" },
  { Masters: 770.0, state: "Andhra Pradesh", city: "Rajahmundry" },
  { Masters: 771.0, state: "Rajasthan", city: "Rajakhera" },
  { Masters: 772.0, state: "Rajasthan", city: "Rajaldesar" },
  { Masters: 773.0, state: "Andhra Pradesh", city: "Rajam" },
  { Masters: 774.0, state: "Andhra Pradesh", city: "Rajampet" },
  { Masters: 775.0, state: "Tamil Nadu", city: "Rajapalayam" },
  { Masters: 776.0, state: "Jammu and Kashmir", city: "Rajauri" },
  { Masters: 777.0, state: "Madhya Pradesh", city: "Rajgarh" },
  { Masters: 778.0, state: "Rajasthan", city: "Rajgarh (Alwar)" },
  { Masters: 779.0, state: "Rajasthan", city: "Rajgarh (Churu)" },
  { Masters: 780.0, state: "Bihar", city: "Rajgir" },
  { Masters: 781.0, state: "Gujarat", city: "Rajkot" },
  { Masters: 782.0, state: "Chhattisgarh", city: "Rajnandgaon" },
  { Masters: 783.0, state: "Gujarat", city: "Rajpipla" },
  { Masters: 784.0, state: "Punjab", city: "Rajpura" },
  { Masters: 785.0, state: "Rajasthan", city: "Rajsamand" },
  { Masters: 786.0, state: "Gujarat", city: "Rajula" },
  { Masters: 787.0, state: "Maharashtra", city: "Rajura" },
  { Masters: 788.0, state: "Andhra Pradesh", city: "Ramachandrapuram" },
  { Masters: 789.0, state: "Telangana", city: "Ramagundam" },
  { Masters: 790.0, state: "Karnataka", city: "Ramanagaram" },
  { Masters: 791.0, state: "Tamil Nadu", city: "Ramanathapuram" },
  { Masters: 792.0, state: "Karnataka", city: "Ramdurg" },
  { Masters: 793.0, state: "Tamil Nadu", city: "Rameshwaram" },
  { Masters: 794.0, state: "Rajasthan", city: "Ramganj Mandi" },
  { Masters: 795.0, state: "Jharkhand", city: "Ramgarh" },
  { Masters: 796.0, state: "Bihar", city: "Ramnagar" },
  { Masters: 797.0, state: "Uttarakhand", city: "Ramnagar" },
  { Masters: 798.0, state: "Rajasthan", city: "Ramngarh" },
  { Masters: 799.0, state: "Uttar Pradesh", city: "Rampur" },
  { Masters: 800.0, state: "Punjab", city: "Rampura Phul" },
  { Masters: 801.0, state: "West Bengal", city: "Rampurhat" },
  { Masters: 802.0, state: "Uttar Pradesh", city: "Rampur Maniharan" },
  { Masters: 803.0, state: "Maharashtra", city: "Ramtek" },
  { Masters: 804.0, state: "West Bengal", city: "Ranaghat" },
  { Masters: 805.0, state: "Gujarat", city: "Ranavav" },
  { Masters: 806.0, state: "Jharkhand", city: "Ranchi" },
  { Masters: 807.0, state: "Karnataka", city: "Ranebennuru" },
  { Masters: 808.0, state: "Assam", city: "Rangia" },
  { Masters: 809.0, state: "Haryana", city: "Rania" },
  { Masters: 810.0, state: "Karnataka", city: "Ranibennur" },
  { Masters: 811.0, state: "Tamil Nadu", city: "Ranipet" },
  { Masters: 812.0, state: "Gujarat", city: "Rapar" },
  { Masters: 813.0, state: "Tamil Nadu", city: "Rasipuram" },
  { Masters: 814.0, state: "Uttar Pradesh", city: "Rasra" },
  { Masters: 815.0, state: "Rajasthan", city: "Ratangarh" },
  { Masters: 816.0, state: "Uttar Pradesh", city: "Rath" },
  { Masters: 817.0, state: "Haryana", city: "Ratia" },
  { Masters: 818.0, state: "Madhya Pradesh", city: "Ratlam" },
  { Masters: 819.0, state: "Maharashtra", city: "Ratnagiri" },
  { Masters: 820.0, state: "Madhya Pradesh", city: "Rau" },
  { Masters: 821.0, state: "Odisha", city: "Raurkela" },
  { Masters: 822.0, state: "Maharashtra", city: "Raver" },
  { Masters: 823.0, state: "Rajasthan", city: "Rawatbhata" },
  { Masters: 824.0, state: "Rajasthan", city: "Rawatsar" },
  { Masters: 825.0, state: "Bihar", city: "Raxaul Bazar" },
  { Masters: 826.0, state: "Andhra Pradesh", city: "Rayachoti" },
  { Masters: 827.0, state: "Andhra Pradesh", city: "Rayadurg" },
  { Masters: 828.0, state: "Odisha", city: "Rayagada" },
  { Masters: 829.0, state: "Gujarat", city: "Raysan" },
  { Masters: 830.0, state: "Rajasthan", city: "Reengus" },
  { Masters: 831.0, state: "Madhya Pradesh", city: "Rehli" },
  { Masters: 832.0, state: "Andhra Pradesh", city: "Renigunta" },
  { Masters: 833.0, state: "Uttar Pradesh", city: "Renukoot" },
  { Masters: 834.0, state: "Uttar Pradesh", city: "Reoti" },
  { Masters: 835.0, state: "Andhra Pradesh", city: "Repalle" },
  { Masters: 836.0, state: "Bihar", city: "Revelganj" },
  { Masters: 837.0, state: "Madhya Pradesh", city: "Rewa" },
  { Masters: 838.0, state: "Haryana", city: "Rewari" },
  { Masters: 839.0, state: "Uttarakhand", city: "Rishikesh" },
  { Masters: 840.0, state: "Maharashtra", city: "Risod" },
  { Masters: 841.0, state: "Uttar Pradesh", city: "Robertsganj" },
  { Masters: 842.0, state: "Karnataka", city: "Robertson Pet" },
  { Masters: 843.0, state: "Haryana", city: "Rohtak" },
  { Masters: 844.0, state: "Karnataka", city: "Ron" },
  { Masters: 845.0, state: "Uttarakhand", city: "Roorkee" },
  { Masters: 846.0, state: "Bihar", city: "Rosera" },
  { Masters: 847.0, state: "Uttar Pradesh", city: "Rudauli" },
  { Masters: 848.0, state: "Uttar Pradesh", city: "Rudrapur" },
  { Masters: 849.0, state: "Uttarakhand", city: "Rudrapur" },
  { Masters: 850.0, state: "Punjab", city: "Rupnagar" },
  { Masters: 851.0, state: "Madhya Pradesh", city: "Sabalgarh" },
  { Masters: 852.0, state: "Uttar Pradesh", city: "Sadabad" },
  { Masters: 853.0, state: "Karnataka", city: "Sadalagi" },
  { Masters: 854.0, state: "Telangana", city: "Sadasivpet" },
  { Masters: 855.0, state: "Rajasthan", city: "Sadri" },
  { Masters: 856.0, state: "Rajasthan", city: "Sadulpur" },
  { Masters: 857.0, state: "Rajasthan", city: "Sadulshahar" },
  { Masters: 858.0, state: "Haryana", city: "Safidon" },
  { Masters: 859.0, state: "Uttar Pradesh", city: "Safipur" },
  { Masters: 860.0, state: "Madhya Pradesh", city: "Sagar" },
  { Masters: 861.0, state: "Karnataka", city: "Sagara" },
  { Masters: 862.0, state: "Rajasthan", city: "Sagwara" },
  { Masters: 863.0, state: "Uttar Pradesh", city: "Saharanpur" },
  { Masters: 864.0, state: "Bihar", city: "Saharsa" },
  { Masters: 865.0, state: "Uttar Pradesh", city: "Sahaspur" },
  { Masters: 866.0, state: "Uttar Pradesh", city: "Sahaswan" },
  { Masters: 867.0, state: "Uttar Pradesh", city: "Sahawar" },
  { Masters: 868.0, state: "Jharkhand", city: "Sahibganj" },
  { Masters: 869.0, state: "Uttar Pradesh", city: "Sahjanwa" },
  { Masters: 870.0, state: "Uttar Pradesh", city: "Saidpur" },
  { Masters: 871.0, state: "Mizoram", city: "Saiha" },
  { Masters: 872.0, state: "Maharashtra", city: "Sailu" },
  { Masters: 873.0, state: "West Bengal", city: "Sainthia" },
  { Masters: 874.0, state: "Karnataka", city: "Sakaleshapura" },
  { Masters: 875.0, state: "Chhattisgarh", city: "Sakti" },
  { Masters: 876.0, state: "Gujarat", city: "Salaya" },
  { Masters: 877.0, state: "Tamil Nadu", city: "Salem" },
  { Masters: 878.0, state: "Andhra Pradesh", city: "Salur" },
  { Masters: 879.0, state: "Haryana", city: "Samalkha" },
  { Masters: 880.0, state: "Andhra Pradesh", city: "Samalkot" },
  { Masters: 881.0, state: "Punjab", city: "Samana" },
  { Masters: 882.0, state: "Bihar", city: "Samastipur" },
  { Masters: 883.0, state: "Odisha", city: "Sambalpur" },
  { Masters: 884.0, state: "Uttar Pradesh", city: "Sambhal" },
  { Masters: 885.0, state: "Rajasthan", city: "Sambhar" },
  { Masters: 886.0, state: "Uttar Pradesh", city: "Samdhan" },
  { Masters: 887.0, state: "Uttar Pradesh", city: "Samthar" },
  { Masters: 888.0, state: "Gujarat", city: "Sanand" },
  { Masters: 889.0, state: "Madhya Pradesh", city: "Sanawad" },
  { Masters: 890.0, state: "Rajasthan", city: "Sanchore" },
  { Masters: 891.0, state: "Uttar Pradesh", city: "Sandi" },
  { Masters: 892.0, state: "Uttar Pradesh", city: "Sandila" },
  { Masters: 893.0, state: "Karnataka", city: "Sanduru" },
  { Masters: 894.0, state: "Maharashtra", city: "Sangamner" },
  { Masters: 895.0, state: "Telangana", city: "Sangareddy" },
  { Masters: 896.0, state: "Rajasthan", city: "Sangaria" },
  { Masters: 897.0, state: "Maharashtra", city: "Sangli" },
  { Masters: 898.0, state: "Maharashtra", city: "Sangole" },
  { Masters: 899.0, state: "Punjab", city: "Sangrur" },
  { Masters: 900.0, state: "Tamil Nadu", city: "Sankarankovil" },
  { Masters: 901.0, state: "Tamil Nadu", city: "Sankari" },
  { Masters: 902.0, state: "Karnataka", city: "Sankeshwara" },
  { Masters: 903.0, state: "West Bengal", city: "Santipur" },
  { Masters: 904.0, state: "Madhya Pradesh", city: "Sarangpur" },
  { Masters: 905.0, state: "Rajasthan", city: "Sardarshahar" },
  { Masters: 906.0, state: "Uttar Pradesh", city: "Sardhana" },
  { Masters: 907.0, state: "Madhya Pradesh", city: "Sarni" },
  { Masters: 908.0, state: "Haryana", city: "Sarsod" },
  { Masters: 909.0, state: "Bihar", city: "Sasaram" },
  { Masters: 910.0, state: "Maharashtra", city: "Sasvad" },
  { Masters: 911.0, state: "Maharashtra", city: "Satana" },
  { Masters: 912.0, state: "Maharashtra", city: "Satara" },
  { Masters: 913.0, state: "Tamil Nadu", city: "Sathyamangalam" },
  { Masters: 914.0, state: "Madhya Pradesh", city: "Satna" },
  { Masters: 915.0, state: "Andhra Pradesh", city: "Sattenapalle" },
  { Masters: 916.0, state: "Tamil Nadu", city: "Sattur" },
  { Masters: 917.0, state: "Jharkhand", city: "Saunda" },
  { Masters: 918.0, state: "Karnataka", city: "Saundatti-Yellamma" },
  { Masters: 919.0, state: "Madhya Pradesh", city: "Sausar" },
  { Masters: 920.0, state: "Karnataka", city: "Savanur" },
  { Masters: 921.0, state: "Gujarat", city: "Savarkundla" },
  { Masters: 922.0, state: "Maharashtra", city: "Savner" },
  { Masters: 923.0, state: "Rajasthan", city: "Sawai Madhopur" },
  { Masters: 924.0, state: "Maharashtra", city: "Sawantwadi" },
  { Masters: 925.0, state: "Karnataka", city: "Sedam" },
  { Masters: 926.0, state: "Madhya Pradesh", city: "Sehore" },
  { Masters: 927.0, state: "Madhya Pradesh", city: "Sendhwa" },
  { Masters: 928.0, state: "Uttar Pradesh", city: "Seohara" },
  { Masters: 929.0, state: "Madhya Pradesh", city: "Seoni" },
  { Masters: 930.0, state: "Madhya Pradesh", city: "Seoni-Malwa" },
  { Masters: 931.0, state: "Karnataka", city: "Shahabad" },
  { Masters: 932.0, state: "Uttar Pradesh", city: "Shahabad, Hardoi" },
  { Masters: 933.0, state: "Uttar Pradesh", city: "Shahabad, Rampur" },
  { Masters: 934.0, state: "Maharashtra", city: "Shahade" },
  { Masters: 935.0, state: "Haryana", city: "Shahbad" },
  { Masters: 936.0, state: "Madhya Pradesh", city: "Shahdol" },
  { Masters: 937.0, state: "Uttar Pradesh", city: "Shahganj" },
  { Masters: 938.0, state: "Uttar Pradesh", city: "Shahjahanpur" },
  { Masters: 939.0, state: "Karnataka", city: "Shahpur" },
  { Masters: 940.0, state: "Rajasthan", city: "Shahpura" },
  { Masters: 941.0, state: "Rajasthan", city: "Shahpura" },
  { Masters: 942.0, state: "Madhya Pradesh", city: "Shajapur" },
  { Masters: 943.0, state: "Madhya Pradesh", city: "Shamgarh" },
  { Masters: 944.0, state: "Uttar Pradesh", city: "Shamli" },
  { Masters: 945.0, state: "Uttar Pradesh", city: "Shamsabad, Agra" },
  {
    Masters: 946.0,
    state: "Uttar Pradesh",
    city: "Shamsabad, Farrukhabad",
  },
  { Masters: 947.0, state: "Maharashtra", city: "Shegaon" },
  { Masters: 948.0, state: "Bihar", city: "Sheikhpura" },
  { Masters: 949.0, state: "Maharashtra", city: "Shendurjana" },
  { Masters: 950.0, state: "Tamil Nadu", city: "Shenkottai" },
  { Masters: 951.0, state: "Rajasthan", city: "Sheoganj" },
  { Masters: 952.0, state: "Bihar", city: "Sheohar" },
  { Masters: 953.0, state: "Madhya Pradesh", city: "Sheopur" },
  { Masters: 954.0, state: "Bihar", city: "Sherghati" },
  { Masters: 955.0, state: "Uttar Pradesh", city: "Sherkot" },
  { Masters: 956.0, state: "Karnataka", city: "Shiggaon" },
  { Masters: 957.0, state: "Karnataka", city: "Shikaripur" },
  {
    Masters: 958.0,
    state: "Uttar Pradesh",
    city: "Shikarpur, Bulandshahr",
  },
  { Masters: 959.0, state: "Uttar Pradesh", city: "Shikohabad" },
  { Masters: 960.0, state: "Meghalaya", city: "Shillong" },
  { Masters: 961.0, state: "Himachal Pradesh", city: "Shimla" },
  { Masters: 962.0, state: "Maharashtra", city: "Shirdi" },
  { Masters: 963.0, state: "Maharashtra", city: "Shirpur-Warwade" },
  { Masters: 964.0, state: "Maharashtra", city: "Shirur" },
  { Masters: 965.0, state: "Uttar Pradesh", city: "Shishgarh" },
  { Masters: 966.0, state: "Karnataka", city: "Shivamogga" },
  { Masters: 967.0, state: "Madhya Pradesh", city: "Shivpuri" },
  { Masters: 968.0, state: "Tamil Nadu", city: "Sholavandan" },
  { Masters: 969.0, state: "Tamil Nadu", city: "Sholingur" },
  { Masters: 970.0, state: "Kerala", city: "Shoranur" },
  { Masters: 971.0, state: "Maharashtra", city: "Shrigonda" },
  { Masters: 972.0, state: "Maharashtra", city: "Shrirampur" },
  { Masters: 973.0, state: "Karnataka", city: "Shrirangapattana" },
  { Masters: 974.0, state: "Madhya Pradesh", city: "Shujalpur" },
  { Masters: 975.0, state: "Uttar Pradesh", city: "Siana" },
  { Masters: 976.0, state: "Assam", city: "Sibsagar" },
  { Masters: 977.0, state: "Telangana", city: "Siddipet" },
  { Masters: 978.0, state: "Madhya Pradesh", city: "Sidhi" },
  { Masters: 979.0, state: "Gujarat", city: "Sidhpur" },
  { Masters: 980.0, state: "Karnataka", city: "Sidlaghatta" },
  { Masters: 981.0, state: "Gujarat", city: "Sihor" },
  { Masters: 982.0, state: "Madhya Pradesh", city: "Sihora" },
  { Masters: 983.0, state: "Uttar Pradesh", city: "Sikanderpur" },
  { Masters: 984.0, state: "Uttar Pradesh", city: "Sikandrabad" },
  { Masters: 985.0, state: "Uttar Pradesh", city: "Sikandra Rao" },
  { Masters: 986.0, state: "Rajasthan", city: "Sikar" },
  { Masters: 987.0, state: "Bihar", city: "Silao" },
  { Masters: 988.0, state: "Assam", city: "Silapathar" },
  { Masters: 989.0, state: "Assam", city: "Silchar" },
  { Masters: 990.0, state: "West Bengal", city: "Siliguri" },
  { Masters: 991.0, state: "Maharashtra", city: "Sillod" },
  { Masters: 992.0, state: "Dadar and Nagar Haveli", city: "Silvassa" },
  { Masters: 993.0, state: "Jharkhand", city: "Simdega" },
  { Masters: 994.0, state: "Karnataka", city: "Sindagi" },
  { Masters: 995.0, state: "Karnataka", city: "Sindhagi" },
  { Masters: 996.0, state: "Karnataka", city: "Sindhnur" },
  { Masters: 997.0, state: "Madhya Pradesh", city: "Singrauli" },
  { Masters: 998.0, state: "Maharashtra", city: "Sinnar" },
  { Masters: 999.0, state: "Karnataka", city: "Sira" },
  { Masters: 1000.0, state: "Telangana", city: "Sircilla" },
  { Masters: 1001.0, state: "Punjab", city: "Sirhind Fatehgarh Sahib" },
  { Masters: 1002.0, state: "Tamil Nadu", city: "Sirkali" },
  { Masters: 1003.0, state: "Himachal Pradesh", city: "Sirmaur" },
  { Masters: 1004.0, state: "Rajasthan", city: "Sirohi" },
  { Masters: 1005.0, state: "Madhya Pradesh", city: "Sironj" },
  { Masters: 1006.0, state: "Haryana", city: "Sirsa" },
  { Masters: 1007.0, state: "Uttar Pradesh", city: "Sirsaganj" },
  { Masters: 1008.0, state: "Karnataka", city: "Sirsi" },
  { Masters: 1009.0, state: "Uttar Pradesh", city: "Sirsi" },
  { Masters: 1010.0, state: "Karnataka", city: "Siruguppa" },
  { Masters: 1011.0, state: "Bihar", city: "Sitamarhi" },
  { Masters: 1012.0, state: "Uttar Pradesh", city: "Sitapur" },
  { Masters: 1013.0, state: "Uttarakhand", city: "Sitarganj" },
  { Masters: 1014.0, state: "Tamil Nadu", city: "Sivaganga" },
  { Masters: 1015.0, state: "Tamil Nadu", city: "Sivagiri" },
  { Masters: 1016.0, state: "Tamil Nadu", city: "Sivakasi" },
  { Masters: 1017.0, state: "Bihar", city: "Siwan" },
  { Masters: 1018.0, state: "Madhya Pradesh", city: "Sohagpur" },
  { Masters: 1019.0, state: "Haryana", city: "Sohna" },
  { Masters: 1020.0, state: "Rajasthan", city: "Sojat" },
  { Masters: 1021.0, state: "Himachal Pradesh", city: "Solan" },
  { Masters: 1022.0, state: "Maharashtra", city: "Solapur" },
  { Masters: 1023.0, state: "West Bengal", city: "Sonamukhi" },
  { Masters: 1024.0, state: "Bihar", city: "Sonepur" },
  { Masters: 1025.0, state: "Gujarat", city: "Songadh" },
  { Masters: 1026.0, state: "Haryana", city: "Sonipat" },
  { Masters: 1027.0, state: "Jammu and Kashmir", city: "Sopore" },
  { Masters: 1028.0, state: "Odisha", city: "Soro" },
  { Masters: 1029.0, state: "Uttar Pradesh", city: "Soron" },
  { Masters: 1030.0, state: "Maharashtra", city: "Soyagaon" },
  { Masters: 1031.0, state: "Andhra Pradesh", city: "Srikakulam" },
  { Masters: 1032.0, state: "Andhra Pradesh", city: "Srikalahasti" },
  { Masters: 1033.0, state: "Rajasthan", city: "Sri Madhopur" },
  { Masters: 1034.0, state: "Uttarakhand", city: "Srinagar" },
  { Masters: 1035.0, state: "Jammu and Kashmir", city: "Srinagar" },
  { Masters: 1036.0, state: "Karnataka", city: "Srinivaspur" },
  { Masters: 1037.0, state: "West Bengal", city: "Srirampore" },
  {
    Masters: 1038.0,
    state: "Andhra Pradesh",
    city: "Srisailam Project (Right Flank Colony) Township",
  },
  { Masters: 1039.0, state: "Tamil Nadu", city: "Srivilliputhur" },
  { Masters: 1040.0, state: "Bihar", city: "Sugauli" },
  { Masters: 1041.0, state: "Rajasthan", city: "Sujangarh" },
  { Masters: 1042.0, state: "Punjab", city: "Sujanpur" },
  { Masters: 1043.0, state: "Andhra Pradesh", city: "Sullurpeta" },
  { Masters: 1044.0, state: "Bihar", city: "Sultanganj" },
  { Masters: 1045.0, state: "Uttar Pradesh", city: "Sultanpur" },
  { Masters: 1046.0, state: "Rajasthan", city: "Sumerpur" },
  { Masters: 1047.0, state: "Uttar Pradesh", city: "Sumerpur" },
  { Masters: 1048.0, state: "Odisha", city: "Sunabeda" },
  { Masters: 1049.0, state: "Punjab", city: "Sunam" },
  { Masters: 1050.0, state: "Odisha", city: "Sundargarh" },
  { Masters: 1051.0, state: "Himachal Pradesh", city: "Sundarnagar" },
  { Masters: 1052.0, state: "Bihar", city: "Supaul" },
  { Masters: 1053.0, state: "Tamil Nadu", city: "Surandai" },
  { Masters: 1054.0, state: "Karnataka", city: "Surapura" },
  { Masters: 1055.0, state: "Gujarat", city: "Surat" },
  { Masters: 1056.0, state: "Rajasthan", city: "Suratgarh" },
  {
    Masters: 1057.0,
    state: "Uttar Pradesh",
    city: "SUrban Agglomerationr",
  },
  { Masters: 1058.0, state: "West Bengal", city: "Suri" },
  { Masters: 1059.0, state: "Tamil Nadu", city: "Suriyampalayam" },
  { Masters: 1060.0, state: "Telangana", city: "Suryapet" },
  { Masters: 1061.0, state: "Andhra Pradesh", city: "Tadepalligudem" },
  { Masters: 1062.0, state: "Andhra Pradesh", city: "Tadpatri" },
  { Masters: 1063.0, state: "Rajasthan", city: "Takhatgarh" },
  { Masters: 1064.0, state: "West Bengal", city: "Taki" },
  { Masters: 1065.0, state: "Gujarat", city: "Talaja" },
  { Masters: 1066.0, state: "Odisha", city: "Talcher" },
  { Masters: 1067.0, state: "Maharashtra", city: "Talegaon Dabhade" },
  { Masters: 1068.0, state: "Karnataka", city: "Talikota" },
  { Masters: 1069.0, state: "Kerala", city: "Taliparamba" },
  { Masters: 1070.0, state: "Maharashtra", city: "Talode" },
  { Masters: 1071.0, state: "Punjab", city: "Talwara" },
  { Masters: 1072.0, state: "West Bengal", city: "Tamluk" },
  { Masters: 1073.0, state: "Uttar Pradesh", city: "Tanda" },
  { Masters: 1074.0, state: "Telangana", city: "Tandur" },
  { Masters: 1075.0, state: "Andhra Pradesh", city: "Tanuku" },
  { Masters: 1076.0, state: "West Bengal", city: "Tarakeswar" },
  { Masters: 1077.0, state: "Madhya Pradesh", city: "Tarana" },
  { Masters: 1078.0, state: "Rajasthan", city: "Taranagar" },
  { Masters: 1079.0, state: "Haryana", city: "Taraori" },
  { Masters: 1080.0, state: "Odisha", city: "Tarbha" },
  { Masters: 1081.0, state: "Karnataka", city: "Tarikere" },
  { Masters: 1082.0, state: "Punjab", city: "Tarn Taran" },
  { Masters: 1083.0, state: "Maharashtra", city: "Tasgaon" },
  { Masters: 1084.0, state: "Uttarakhand", city: "Tehri" },
  { Masters: 1085.0, state: "Karnataka", city: "Tekkalakote" },
  { Masters: 1086.0, state: "Andhra Pradesh", city: "Tenali" },
  { Masters: 1087.0, state: "Tamil Nadu", city: "Tenkasi" },
  { Masters: 1088.0, state: "Jharkhand", city: "Tenu dam-cum-Kathhara" },
  { Masters: 1089.0, state: "Karnataka", city: "Terdal" },
  { Masters: 1090.0, state: "Assam", city: "Tezpur" },
  { Masters: 1091.0, state: "Uttar Pradesh", city: "Thakurdwara" },
  { Masters: 1092.0, state: "Tamil Nadu", city: "Thammampatti" },
  { Masters: 1093.0, state: "Uttar Pradesh", city: "Thana Bhawan" },
  { Masters: 1094.0, state: "Maharashtra", city: "Thane" },
  { Masters: 1095.0, state: "Haryana", city: "Thanesar" },
  { Masters: 1096.0, state: "Gujarat", city: "Thangadh" },
  { Masters: 1097.0, state: "Tamil Nadu", city: "Thanjavur" },
  { Masters: 1098.0, state: "Gujarat", city: "Tharad" },
  { Masters: 1099.0, state: "Tamil Nadu", city: "Tharamangalam" },
  { Masters: 1100.0, state: "Tamil Nadu", city: "Tharangambadi" },
  { Masters: 1101.0, state: "Tamil Nadu", city: "Theni Allinagaram" },
  { Masters: 1102.0, state: "Tamil Nadu", city: "Thirumangalam" },
  { Masters: 1103.0, state: "Tamil Nadu", city: "Thirupuvanam" },
  { Masters: 1104.0, state: "Tamil Nadu", city: "Thiruthuraipoondi" },
  { Masters: 1105.0, state: "Kerala", city: "Thiruvalla" },
  { Masters: 1106.0, state: "Tamil Nadu", city: "Thiruvallur" },
  { Masters: 1107.0, state: "Kerala", city: "Thiruvananthapuram" },
  { Masters: 1108.0, state: "Tamil Nadu", city: "Thiruvarur" },
  { Masters: 1109.0, state: "Kerala", city: "Thodupuzha" },
  { Masters: 1110.0, state: "Manipur", city: "Thoubal" },
  { Masters: 1111.0, state: "Kerala", city: "Thrissur" },
  { Masters: 1112.0, state: "Tamil Nadu", city: "Thuraiyur" },
  { Masters: 1113.0, state: "Madhya Pradesh", city: "Tikamgarh" },
  { Masters: 1114.0, state: "Chhattisgarh", city: "Tilda Newra" },
  { Masters: 1115.0, state: "Uttar Pradesh", city: "Tilhar" },
  { Masters: 1116.0, state: "Tamil Nadu", city: "Tindivanam" },
  { Masters: 1117.0, state: "Assam", city: "Tinsukia" },
  { Masters: 1118.0, state: "Karnataka", city: "Tiptur" },
  { Masters: 1119.0, state: "Maharashtra", city: "Tirora" },
  { Masters: 1120.0, state: "Tamil Nadu", city: "Tiruchendur" },
  { Masters: 1121.0, state: "Tamil Nadu", city: "Tiruchengode" },
  { Masters: 1122.0, state: "Tamil Nadu", city: "Tirukalukundram" },
  { Masters: 1123.0, state: "Tamil Nadu", city: "Tirukkoyilur" },
  { Masters: 1124.0, state: "Tamil Nadu", city: "Tirunelveli" },
  { Masters: 1125.0, state: "Tamil Nadu", city: "Tirupathur" },
  { Masters: 1126.0, state: "Tamil Nadu", city: "Tirupathur" },
  { Masters: 1127.0, state: "Andhra Pradesh", city: "Tirupati" },
  { Masters: 1128.0, state: "Tamil Nadu", city: "Tiruppur" },
  { Masters: 1129.0, state: "Kerala", city: "Tirur" },
  { Masters: 1130.0, state: "Tamil Nadu", city: "Tiruttani" },
  { Masters: 1131.0, state: "Tamil Nadu", city: "Tiruvannamalai" },
  { Masters: 1132.0, state: "Tamil Nadu", city: "Tiruvethipuram" },
  { Masters: 1133.0, state: "Andhra Pradesh", city: "Tiruvuru" },
  { Masters: 1134.0, state: "Uttar Pradesh", city: "Tirwaganj" },
  { Masters: 1135.0, state: "Odisha", city: "Titlagarh" },
  { Masters: 1136.0, state: "Tamil Nadu", city: "Tittakudi" },
  { Masters: 1137.0, state: "Rajasthan", city: "Todabhim" },
  { Masters: 1138.0, state: "Rajasthan", city: "Todaraisingh" },
  { Masters: 1139.0, state: "Haryana", city: "Tohana" },
  { Masters: 1140.0, state: "Rajasthan", city: "Tonk" },
  { Masters: 1141.0, state: "Tamil Nadu", city: "Trichy" },
  { Masters: 1142.0, state: "Nagaland", city: "Tuensang" },
  { Masters: 1143.0, state: "Maharashtra", city: "Tuljapur" },
  { Masters: 1144.0, state: "Uttar Pradesh", city: "Tulsipur" },
  { Masters: 1145.0, state: "Karnataka", city: "Tumkur" },
  { Masters: 1146.0, state: "Maharashtra", city: "Tumsar" },
  { Masters: 1147.0, state: "Uttar Pradesh", city: "Tundla" },
  { Masters: 1148.0, state: "Andhra Pradesh", city: "Tuni" },
  { Masters: 1149.0, state: "Meghalaya", city: "Tura" },
  { Masters: 1150.0, state: "Maharashtra", city: "Uchgaon" },
  { Masters: 1151.0, state: "Rajasthan", city: "Udaipur" },
  { Masters: 1152.0, state: "Tripura", city: "Udaipur" },
  { Masters: 1153.0, state: "Rajasthan", city: "Udaipurwati" },
  { Masters: 1154.0, state: "Maharashtra", city: "Udgir" },
  { Masters: 1155.0, state: "Tamil Nadu", city: "Udhagamandalam" },
  { Masters: 1156.0, state: "Jammu and Kashmir", city: "Udhampur" },
  { Masters: 1157.0, state: "Tamil Nadu", city: "Udumalaipettai" },
  { Masters: 1158.0, state: "Karnataka", city: "Udupi" },
  { Masters: 1159.0, state: "Uttar Pradesh", city: "Ujhani" },
  { Masters: 1160.0, state: "Madhya Pradesh", city: "Ujjain" },
  { Masters: 1161.0, state: "Maharashtra", city: "Umarga" },
  { Masters: 1162.0, state: "Madhya Pradesh", city: "Umaria" },
  { Masters: 1163.0, state: "Maharashtra", city: "Umarkhed" },
  { Masters: 1164.0, state: "Gujarat", city: "Umbergaon" },
  { Masters: 1165.0, state: "Maharashtra", city: "Umred" },
  { Masters: 1166.0, state: "Gujarat", city: "Umreth" },
  { Masters: 1167.0, state: "Gujarat", city: "Una" },
  { Masters: 1168.0, state: "Gujarat", city: "Unjha" },
  { Masters: 1169.0, state: "Tamil Nadu", city: "Unnamalaikadai" },
  { Masters: 1170.0, state: "Uttar Pradesh", city: "Unnao" },
  { Masters: 1171.0, state: "Gujarat", city: "Upleta" },
  { Masters: 1172.0, state: "Maharashtra", city: "Uran" },
  { Masters: 1173.0, state: "Maharashtra", city: "Uran Islampur" },
  { Masters: 1174.0, state: "Andhra Pradesh", city: "Uravakonda" },
  { Masters: 1175.0, state: "Punjab", city: "Urmar Tanda" },
  { Masters: 1176.0, state: "Tamil Nadu", city: "Usilampatti" },
  { Masters: 1177.0, state: "Tamil Nadu", city: "Uthamapalayam" },
  { Masters: 1178.0, state: "Tamil Nadu", city: "Uthiramerur" },
  { Masters: 1179.0, state: "Uttar Pradesh", city: "Utraula" },
  { Masters: 1180.0, state: "Tamil Nadu", city: "Vadakkuvalliyur" },
  { Masters: 1181.0, state: "Tamil Nadu", city: "Vadalur" },
  { Masters: 1182.0, state: "Maharashtra", city: "Vadgaon Kasba" },
  { Masters: 1183.0, state: "Tamil Nadu", city: "Vadipatti" },
  { Masters: 1184.0, state: "Gujarat", city: "Vadnagar" },
  { Masters: 1185.0, state: "Gujarat", city: "Vadodara" },
  { Masters: 1186.0, state: "Maharashtra", city: "Vaijapur" },
  { Masters: 1187.0, state: "Kerala", city: "Vaikom" },
  { Masters: 1188.0, state: "Tamil Nadu", city: "Valparai" },
  { Masters: 1189.0, state: "Gujarat", city: "Valsad" },
  { Masters: 1190.0, state: "Tamil Nadu", city: "Vandavasi" },
  { Masters: 1191.0, state: "Tamil Nadu", city: "Vaniyambadi" },
  { Masters: 1192.0, state: "Gujarat", city: "Vapi" },
  { Masters: 1193.0, state: "Gujarat", city: "Vapi" },
  { Masters: 1194.0, state: "Uttar Pradesh", city: "Varanasi" },
  { Masters: 1195.0, state: "Kerala", city: "Varkala" },
  { Masters: 1196.0, state: "Maharashtra", city: "Vasai-Virar" },
  { Masters: 1197.0, state: "Kerala", city: "Vatakara" },
  { Masters: 1198.0, state: "Tamil Nadu", city: "Vedaranyam" },
  { Masters: 1199.0, state: "Tamil Nadu", city: "Vellakoil" },
  { Masters: 1200.0, state: "Tamil Nadu", city: "Vellore" },
  { Masters: 1201.0, state: "Andhra Pradesh", city: "Venkatagiri" },
  { Masters: 1202.0, state: "Gujarat", city: "Veraval" },
  { Masters: 1203.0, state: "Madhya Pradesh", city: "Vidisha" },
  { Masters: 1204.0, state: "Rajasthan", city: "Vijainagar, Ajmer" },
  { Masters: 1205.0, state: "Gujarat", city: "Vijapur" },
  { Masters: 1206.0, state: "Karnataka", city: "Vijayapura" },
  { Masters: 1207.0, state: "Andhra Pradesh", city: "Vijayawada" },
  { Masters: 1208.0, state: "Madhya Pradesh", city: "Vijaypur" },
  { Masters: 1209.0, state: "Telangana", city: "Vikarabad" },
  { Masters: 1210.0, state: "Tamil Nadu", city: "Vikramasingapuram" },
  { Masters: 1211.0, state: "Tamil Nadu", city: "Viluppuram" },
  { Masters: 1212.0, state: "Andhra Pradesh", city: "Vinukonda" },
  { Masters: 1213.0, state: "Gujarat", city: "Viramgam" },
  { Masters: 1214.0, state: "Tamil Nadu", city: "Virudhachalam" },
  { Masters: 1215.0, state: "Tamil Nadu", city: "Virudhunagar" },
  { Masters: 1216.0, state: "Andhra Pradesh", city: "Visakhapatnam" },
  { Masters: 1217.0, state: "Gujarat", city: "Visnagar" },
  { Masters: 1218.0, state: "Tamil Nadu", city: "Viswanatham" },
  { Masters: 1219.0, state: "Maharashtra", city: "Vita" },
  { Masters: 1220.0, state: "Andhra Pradesh", city: "Vizianagaram" },
  { Masters: 1221.0, state: "Uttar Pradesh", city: "Vrindavan" },
  { Masters: 1222.0, state: "Gujarat", city: "Vyara" },
  { Masters: 1223.0, state: "Maharashtra", city: "Wadgaon Road" },
  { Masters: 1224.0, state: "Gujarat", city: "Wadhwan" },
  { Masters: 1225.0, state: "Karnataka", city: "Wadi" },
  { Masters: 1226.0, state: "Maharashtra", city: "Wai" },
  { Masters: 1227.0, state: "Telangana", city: "Wanaparthy" },
  { Masters: 1228.0, state: "Maharashtra", city: "Wani" },
  { Masters: 1229.0, state: "Gujarat", city: "Wankaner" },
  { Masters: 1230.0, state: "Telangana", city: "Warangal" },
  { Masters: 1231.0, state: "Madhya Pradesh", city: "Wara Seoni" },
  { Masters: 1232.0, state: "Maharashtra", city: "Wardha" },
  { Masters: 1233.0, state: "Uttar Pradesh", city: "Warhapur" },
  { Masters: 1234.0, state: "Bihar", city: "Warisaliganj" },
  { Masters: 1235.0, state: "Maharashtra", city: "Warora" },
  { Masters: 1236.0, state: "Maharashtra", city: "Warud" },
  { Masters: 1237.0, state: "Maharashtra", city: "Washim" },
  { Masters: 1238.0, state: "Nagaland", city: "Wokha" },
  { Masters: 1239.0, state: "Karnataka", city: "Yadgir" },
  { Masters: 1240.0, state: "Haryana", city: "Yamunanagar" },
  { Masters: 1241.0, state: "Puducherry", city: "Yanam" },
  { Masters: 1242.0, state: "Maharashtra", city: "Yavatmal" },
  { Masters: 1243.0, state: "Maharashtra", city: "Yawal" },
  { Masters: 1244.0, state: "Telangana", city: "Yellandu" },
  { Masters: 1245.0, state: "Andhra Pradesh", city: "Yemmiganur" },
  { Masters: 1246.0, state: "Andhra Pradesh", city: "Yerraguntla" },
  { Masters: 1247.0, state: "Maharashtra", city: "Yevla" },
  { Masters: 1248.0, state: "Uttar Pradesh", city: "Zaidpur" },
  { Masters: 1249.0, state: "Uttar Pradesh", city: "Zamania" },
  { Masters: 1250.0, state: "Punjab", city: "Zira" },
  { Masters: 1251.0, state: "Punjab", city: "Zirakpur" },
  { Masters: 1252.0, state: "Nagaland", city: "Zunheboto" },
];
